import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import Header from "../../components/header";
import Footerb from "../../components/footer-b/component";
import ViewReportIcon from "../../assets/dasboard/view-results-image.svg";
import DownloadReportIcon from "../../assets/dasboard/download-report-image.svg";
import EmailReportIcon from "../../assets/dasboard/email-report-image.svg";
import RetakeTestIcon from "../../assets/dasboard/retake-test-image.svg";
import DeleteReportIcon from "../../assets/dasboard/delete-report-image.svg";
import SendToFriendIcon from "../../assets/dasboard/send-to-friend-image.svg";
import ShareReportIcon from "../../assets/dasboard/share-report-icon.svg";
import ADHDIcon from "../../assets/assessment-icons/ADHD.svg";
import DiSCIcon from "../../assets/assessment-icons/DiSC.svg";
import IqIcon from "../../assets/assessment-icons/iq.svg";
import PersonalityDisorderIcon from "../../assets/assessment-icons/personality-disorder.svg";
import PlayIcon from "../../assets/dasboard/play.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import LearningStyle from "../../assets/sell/learning-style-pic.svg";
import StressManagement from "../../assets/sell/stress-management-pic.svg";
import CareerIcon from "../../assets/assessment-icons/career.svg";
import BigFiveIcon from "../../assets/assessment-icons/big-five.svg";
import BigFiveFacetsIcon from "../../assets/assessment-icons/big-five-facets.svg";
import EnneagramIcon from "../../assets/assessment-icons/enneagram.svg";
import PersonalityIcon from "../../assets/assessment-icons/personality.svg";
import AllIcon from "../../assets/assessment-icons/All.svg";
import DifficultIcon from "../../assets/assessment-icons/difficult.svg";
import LikeabilityIcon from "../../assets/assessment-icons/likability.svg";
import FilterTestIcon from "../../assets/sell/filter-tests-icon.svg";
import NarcissisticIcon from "../../assets/assessment-icons/NPD.svg";
import LoveStyleIcon from "../../assets/assessment-icons/love-style.svg";
import HighlySensitiveIcon from "../../assets/assessment-icons/highly-sensitive.svg";
import FourTempermentsIcon from "../../assets/assessment-icons/four-temperments.svg";
import AntisocialIcon from "../../assets/assessment-icons/antisocial.svg";
import DyslexiaIcon from "../../assets/assessment-icons/dyslexia.svg";
import AutismIcom from "../../assets/assessment-icons/autism.svg";
import PsychopathIcon from "../../assets/assessment-icons/icon-psycholath.svg";
import CareerPreferenceIcon from "../../assets/assessment-icons/icon-career-assessment.svg";
import RomanticCompatibilityIcon from "../../assets/assessment-icons/romantic-compatibility.svg";
import ColorBlindnessIcon from "../../assets/assessment-icons/color-blindness.svg";
import DepressionIcon from "../../assets/assessment-icons/depression.svg";
import BipolarIcon from "../../assets/assessment-icons/icon-bipolar.svg";
import AttachmentStyleIcon from "../../assets/assessment-icons/attachment-style.svg";
import EmotionalIntelligence from "../../assets/assessment-icons/emotional-intelligence.svg";
import ChildhoodTraumaIcon from "../../assets/assessment-icons/childhood-trauma.svg";
import SocialAnxietyIcon from "../../assets/assessment-icons/social-anxiety.svg";
import AutismChildIcon from "../../assets/assessment-icons/autism-child.svg";
import SociopathIcon from "../../assets/assessment-icons/sociopath.svg";
import ShareProfileModal from "../../components/share-modal/component";
import AppPopOver from "../../components/popover";
import AppButton from "../../components/button/component";
import FunnelStepTypes from "../funnel-step/types";
import useMediaQuery from "../../utils/media-query";
import { useDispatch } from "react-redux";
import moment, { locale } from "moment";

import Guid from "guid";
import { toast } from "react-toastify";
import PathHelper from "../../utils/path-helper";
import {
  getOppositeTrait,
  getPersonalityType,
} from "../../utils/personality-helper";
import { CreateNewUserModel } from "../../components/model/component";
import {
  ADHD_TEST_ASSESSMENT_ID,
  ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID,
  ATTACHMENT_STYLE_TEST_ASSESSMENT_ID,
  AUTISM_SPECTRUM_TEST_ASSESSMENT_ID,
  BIG_FIVE_FACETS_TEST_ASSESSMENT_ID,
  BIG_FIVE_TEST_ASSESSMENT_ID,
  CAREER_PREFERENCE_TEST_ASSESSMENT_ID,
  CAREER_TEST_ASSESSMENT_ID,
  DIFFICULT_PERSON_TEST_ASSESSMENT_ID,
  DISC_TEST_ASSESSMENT_ID,
  DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID,
  DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID,
  EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID,
  ENNEAGRAM_TEST_ASSESSMENT_ID,
  FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID,
  HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID,
  LIKEABILITY_TEST_ASSESSMENT_ID,
  LOVE_STYLE_TEST_ASSESSMENT_ID,
  MODEL_TYPE_DASHBOARD,
  NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID,
  PERSONALITY_DISORDER_TEST_ASSESSMENT_ID,
  PERSONALITY_TEST_ASSESSMENT_ID,
  ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
  COLOR_BLINDNESS_TEST_ASSESSMENT_ID,
  DEPRESSION_TEST_ASSESSMENT_ID,
  BIPOLAR_DISORDER_ASSESSMENT_ID,
  PSYCHOPATH_ASSESSMENT_ID,
  CHILDHOOD_TRAUMA_TEST_ASSESSMENT_ID,
  SOCIAL_ANXIETY_TEST_ASSESMENT_ID,
  AUTISM_CHILDREN_TEST_ASSESSMENT_ID,
  SOCIOPATH_TEST_ASSESSMENT_ID,
  IQ_TEST_ASSESSMENT_ID,
} from "../../utils/general-config";

import Loader from "../../components/loader";
import {
  checkUserAttemptAllAssessments,
  convertToLowerCase,
  getAchievementIcon,
  getAssessmentStatuses,
  getBannerImage,
  getColorCode,
  getImage,
  getUniqueAssessmentCompletedCount,
  groupAndSortAssessments,
  InvitationStatus,
  personalityNamesAndGroups,
  REPORT_ROUTES,
  getDashboardAssessmentBannerSrc,
} from "../../utils/utility-functions";
import useSignOut from "../../utils/sign-out";
import { useTranslation } from "react-i18next";
import {
  APP_NAVIGATION,
  ASSESSMENT_STATUS,
  BADGE_TYPE,
  LOCALE,
  ROMANTIC_COMPATIBILITY_REPORT_TYPE,
} from "../../utils/constants";
import MobileBottomSheet from "../../components/mobile-modal/component";
import DashboardQuizB from "../../components/dashboard-quiz-b";
import TakeAssessmentModal from "../../components/take-assessment-modal";
import {
  AssessmentDetailsBodyContent,
  AssessmentOverview,
} from "../../components/assessment-overview/component.js";
import DashboardAssessmentImage from "../../components/assessment-overview/dashboard-assessment-image";
import ResultProfileImage from "../../components/result-profile-image";

const pushResetSelectedAnswerCountToFunnelStep = () => ({
  type: FunnelStepTypes.RESET_SELECTED_ANSWER_COUNT,
});

const PushAssessmentAttemptIdToFunnelStep = (assessmentAttemptId) => ({
  type: FunnelStepTypes.SET_ASSESSMENT_ATTEMPT_ID,
  assessmentAttemptId,
});
const PushQuizCompleteToFunnelStep = (quizComplete) => ({
  type: FunnelStepTypes.SET_QUIZ_COMPLETE,
  quizComplete,
});
const PushAssessmentIdToFunnelStep = (assessmentId) => ({
  type: FunnelStepTypes.SET_ASSESSMENT_ID,
  assessmentId,
});

const PushBackClickCountToFunnelStep = (backCount) => ({
  type: FunnelStepTypes.SET_BACk_BUTTON_CLICK_COUNT,
  backCount,
});

const PushGuestUserToFunnelStep = (guestUser) => {
  return {
    type: FunnelStepTypes.SET_GUEST_USER,
    guestUser,
  };
};
const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});

const PushCompletedAchievements = (completedAchievements) => ({
  type: FunnelStepTypes.SET_COMPLETED_ACHIEVEMENTS,
  completedAchievements,
});

const PushTotalAssessmentAttempts = (totalAssessmentAttempts) => ({
  type: FunnelStepTypes.SET_TOTAL_ASSESSMENT_ATTEMPTS,
  totalAssessmentAttempts,
});

const PushBillingDetails = ({ nextBillingDate }) => ({
  type: FunnelStepTypes.SET_BILLING_DETAILS,
  nextBillingDate,
});

const Dashboard = ({
  getAssessmentResultByAssessmentAttemptIdConnect,
  getAssessmentAttemptByUserIdConnect,
  getAssessmentByIdConnect,
  funnelStep,
  DownloadAssessmentResultConnect,
  GetUserByIdConnect,
  IsGuestOrPremiumUserConnect,
  ShareReportOnEmailConnect,
  DeleteReport,
  GetGuestUserConnect,
  GetBillingConnect,
  GuestUserChangesConnect,
  getInsightfulContentConnect,
  sendToFriendReportOnEmailConnect,
  sendToPartnerReportOnEmailConnect,
  isCompleteRomanticCompatibilityConnect,
  getUserAssessmentResultMapByUserIdConnect,
  getUserAssessmentResultByResultIdConnect,
  getBadgesConnect,
  saveUserSocialButtonClickConnect,
  getUserSocialButtonClickByUserIdConnect,
  getOrderDataByUserIdConnect,
}) => {
  const newAssessmentAttemptId = Guid.create().value;
  const navigate = useNavigate();

  const [guestUserCount, setGuestUserCount] = useState(0);
  const {
    userGUID,

    selectedPlan,
    isGuestUser,
    gender,

    isAuth,
  } = funnelStep || {};
  const { t } = useTranslation();
  const { locale } = useParams();
  const location = useLocation();
  const currentLocale = locale ?? LOCALE.EN;

  const [personalityInProgress, setPersonalityInProgress] = useState(false);
  const [openSendToFriend, setOpenSendToFriend] = useState(false);
  const [openSendToPartner, setOpenSendToPartner] = useState(false);
  const [assessmentTitle, setAssessmentTitle] = useState("");
  const [assessmentAttemptData, setAssessmentAttemptData] = useState([]);
  const [openNewTest, setOpenNewTest] = React.useState(false);
  const [userAssessmentResult, setUserAssessmentResult] = useState({});
  const [popoverOpen, setPopoverOpen] = React.useState({});
  const [isPremiumOrGuest, setIsPremiumOrGuest] = React.useState(false);
  const [transactionDetails, setTransactionDetail] = useState(null);
  const [skuId, setSkuId] = useState("");
  const [billingDetails, setBillingDetails] = useState(null);
  const [openCreateUser, setOpenCreateUser] = useState(false);
  const [guestUserData, setGuestUserData] = useState([]);
  const [userData, setUserData] = useState(null);
  // Achievement states moved to parent to persist across modal state changes
  const [expandedAchievement, setExpandedAchievement] = useState(null);
  const [openedAssessmentAchievement, setOpenedAssessmentAchievement] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [allAssessments, setAllAssessments] = useState([]);
  const [groupedCategories, setGroupedCategories] = useState([]);
  const [insightfulContent, setInsightfulContent] = useState({});
  const [selectedAssessmentId, setSelectedAssessmentId] = useState("");
  const [selectedAssessmentAttemptId, setSelectedAssessmentAttemptId] =
    useState("");
  const [selectedAssessmentMapId, setSelectedAssessmentMaoId] = useState("");
  const [selectedReportType, setSelectedReportType] = useState(null);
  const [selectedResultId, setSelectedResultId] = useState(null);
  const [testPanelOpen, setTestPanelOpen] = useState(null);
  const [assessmentDetailOpen, setAssessmentDetailOpen] = useState(false);
  const [isNewTestPopupOpen, setIsNewTestPopupOpen] = useState(false);
  const [
    inCompletePersonalityAssessmentId,
    setInCompletePersonalityAssessmentId,
  ] = useState("");
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [currentFilter, setCurrentFilter] = useState("All");
  const [totalUserSocialShareCount, setTotalUserSocialShareCount] = useState(0);
  const [badgesData, setBadgesData] = useState([]);
  const handlePopoverClick = (index) => {
    setPopoverOpen((prevOpen) => (prevOpen === index ? null : index));
    setOpenNewTest(false);
  };
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [takeAssessmentModalOpen, setTakeAssessmentModalOpen] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [deleteConfirmParams, setDeleteConfirmParams] = useState(null);
  const [showOnlySpecificCategories, setShowOnlySpecificCategories] =
    useState(false);

  const [viewAllTests, setViewAllTests] = useState(false);
  const isMobile = useMediaQuery("(max-width: 820px)");

  const [selectedTest, setSelectedTest] = useState(null);
  const [userAssessmentResulMapData, setUserAssessmentResulMapData] = useState(
    [],
  );
  const [userAssessmentResultById, setUserAssessmentResultById] = useState([]);
  const [
    isUserAssessmentResulMapDataLoading,
    setIsUserAssessmentResulMapDataLoading,
  ] = useState(false);

  const [showCompleteAssessmentsOnly, setShowCompleteAssessmentsOnly] =
    useState(false);

  const dispatch = useDispatch();

  const TEST_TYPES = {
    [PERSONALITY_TEST_ASSESSMENT_ID]: "PersonalityTest",
    [BIG_FIVE_TEST_ASSESSMENT_ID]: "BigFiveTest",
    [CAREER_TEST_ASSESSMENT_ID]: "CareerTest",
    [ENNEAGRAM_TEST_ASSESSMENT_ID]: "EnneagramTest",
    [BIG_FIVE_FACETS_TEST_ASSESSMENT_ID]: "BigFiveFacetsTest",
    [LIKEABILITY_TEST_ASSESSMENT_ID]: "LikeabilityTest",
    [PERSONALITY_DISORDER_TEST_ASSESSMENT_ID]: "PersonalityDisorderTest",
    [DISC_TEST_ASSESSMENT_ID]: "DiscPersonalityTest",
    [ADHD_TEST_ASSESSMENT_ID]: "ADHDTest",
    [CAREER_PREFERENCE_TEST_ASSESSMENT_ID]: "CareerPreferenceTest",
    [EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID]: "EmotionalIntelligenceTest",
    [DIFFICULT_PERSON_TEST_ASSESSMENT_ID]: "DifficultPersonTest",
    [AUTISM_SPECTRUM_TEST_ASSESSMENT_ID]: "AutismSpectrumTest",
    [HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID]: "HighlySensitivePersonTest",
    [ATTACHMENT_STYLE_TEST_ASSESSMENT_ID]: "AttachmentStyleTest",
    [ROMANTIC_COMPATIBILITY_ASSESSMENT_ID]: "RomanticCompatibilityTest",
  };

  const fetchUserAssessmentData = async () => {
    if (userGUID) {
      setIsUserAssessmentResulMapDataLoading(true);
      try {
        const res = await getUserAssessmentResultMapByUserIdConnect(userGUID);
        setUserAssessmentResulMapData(res);
        setUserAssessmentResultById([]); // Reset the array before populating

        const resultPromises = res.map((item) =>
          getUserAssessmentResultByResultIdConnect(
            item.userAssessmentResultId,
            currentLocale,
          ).then((res) => {
            if (res) {
              setUserAssessmentResultById((prev) => [...(prev || []), res]);
            }
          }),
        );

        await Promise.all(resultPromises);
      } catch (err) {
        console.error("Failed to fetch assessment result map:", err);
      } finally {
        setIsUserAssessmentResulMapDataLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchUserAssessmentData();
  }, [userGUID]);

  useEffect(() => {
    const fetchData = async () => {
      if (!userGUID || isUserAssessmentResulMapDataLoading) return; // Exit if userGUID is not available
      setIsLoading(true);

      try {
        // 1. Fetch Assessment Attempt Data
        const assessmentAttemptData = await getAssessmentAttemptByUserIdConnect(
          userGUID,
          currentLocale,
        );
        setAssessmentAttemptData(assessmentAttemptData);

        // 2. Determine latestAssessmentAttemptId from completed results
        const completedAssessmentResult = assessmentAttemptData.filter(
          (item) =>
            item.assessmentId === PERSONALITY_TEST_ASSESSMENT_ID &&
            item.personality !== null,
        );
        const allCompletedAssessmentResult = assessmentAttemptData.filter(
          (item) => item.personality !== null,
        );

        dispatch(
          PushTotalAssessmentAttempts(allCompletedAssessmentResult.length),
        );

        const inCompletedAssessmentResult = assessmentAttemptData.filter(
          (item) =>
            item.assessmentId === PERSONALITY_TEST_ASSESSMENT_ID &&
            item.personality === null,
        );
        const latestPersonalityInprogress = inCompletedAssessmentResult.sort(
          (a, b) => new Date(b.createdOn) - new Date(a.createdOn),
        );

        const latestPersonalityInprogressAttemptId =
          latestPersonalityInprogress[0]?.assessmentAttemptId;

        if (latestPersonalityInprogress.length > 0) {
          setPersonalityInProgress(true);
          setInCompletePersonalityAssessmentId(
            latestPersonalityInprogressAttemptId,
          );
        }

        const latestAttempt = completedAssessmentResult.sort(
          (a, b) => new Date(b.createdOn) - new Date(a.createdOn),
        )[0];
        const latestAssessmentAttemptId = latestAttempt?.assessmentAttemptId;

        if (!latestAssessmentAttemptId) return; // Exit if no valid attempt found

        // 3. Fetch User Assessment Result
        if (latestAssessmentAttemptId) {
          const userAssessmentResult =
            await getAssessmentResultByAssessmentAttemptIdConnect(
              latestAssessmentAttemptId,
              currentLocale,
            );
          setUserAssessmentResult(userAssessmentResult);
        } else {
          setUserAssessmentResult(null);
        }

        // 4. Fetch Insightful Content based on userAssessmentResult
        if (userAssessmentResult?.personality) {
          const data = {
            modelType: MODEL_TYPE_DASHBOARD[currentLocale],
            contentKey: userAssessmentResult.personality.title.toLowerCase(),
          };
          const insightfulContent = await getInsightfulContentConnect(data);
          setInsightfulContent(insightfulContent);
        }
      } catch (error) {
        console.error(error); // Log errors from any of the fetch operations
      } finally {
        setIsLoading(false); // Stop loading state only after all operations complete
      }
    };

    fetchData();
  }, [
    userGUID,
    getAssessmentAttemptByUserIdConnect,
    getAssessmentResultByAssessmentAttemptIdConnect,
    getInsightfulContentConnect,
  ]);

  // Handle showAssessment query param
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const showAssessment = params.get("showAssessment") === "true";
    if (showAssessment) {
      setTakeAssessmentModalOpen(true);
      // Clean URL immediately after opening modal (remove query params)
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  const signOut = useSignOut();
  useEffect(() => {
    if (!isAuth) {
      signOut({ isNavigate: true });
    }
  }, [isAuth]);

  useEffect(() => {
    if (userGUID) {
      IsGuestOrPremiumUserConnect(userGUID).then((res) => {
        if (!!res) {
          const flag = res?.isPremiumOrGuestUser;
          setIsPremiumOrGuest(flag);
          // createCookie("isPremiumOrGuest", flag, 1);
          const queryParams = new URLSearchParams(window.location.search);
          let isGuestFromQuery = queryParams.has("isguest");
          const shouldSkipTransaction = isGuestUser || isGuestFromQuery;
          if (!shouldSkipTransaction) {
            getOrderDataByUserIdConnect(userGUID).then((res) => {
              if (res && Object.keys(res).length > 0) {
                setTransactionDetail(res);
                try {
                  setSkuId(res.skuId ?? null);
                } catch (error) {
                  setSkuId(null); // optional fallback
                }
              } else {
                setSkuId(null);
              }
            });
          }
        }
      });
    }
  }, [userGUID]);

  const romanticCompatibilityData =
    userAssessmentResultById?.map((result) => ({
      id: result.id,
      assessmentId: result?.assessmentId,
      title: result?.assessmentTitle,
      date: result?.createdOn,
      assessmentAttemptId: result?.assessmentAttemptId,
      personality: result?.personality,
      assessmentMapId: result?.assessmentMapId,
      createdOn: result?.createdOn,
      nameEnglishCode: result?.nameEnglishCode,
      subtitle: t("report.romantic_compatibility.compatibility_report"),
      // Set reportType for compatibility reports
      reportType: ROMANTIC_COMPATIBILITY_REPORT_TYPE.COMPATIBILITY,
      lastModifiedOn: result?.lastModifiedOn || "",
      assessmentCategoryName: result?.assessmentCategoryName || "",
    })) || [];

  const mappedData =
    assessmentAttemptData?.length > 0
      ? assessmentAttemptData.map((item) => ({
          id: item?.id,
          assessmentId: item?.assessmentId,
          title: item?.assessmentTitle,
          subtitle:
            convertToLowerCase(item?.assessmentId) ===
            convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID)
              ? t("report.romantic_compatibility.personalized_report")
              : "",
          date: item?.createdOn,
          assessmentAttemptId: item?.assessmentAttemptId,
          personality: item?.personality,
          assessmentMapId: item?.assessmentMapId,
          createdOn: item?.createdOn,
          nameEnglishCode: item?.nameEnglishCode,
          // Add reportType for romantic compatibility assessments
          reportType:
            convertToLowerCase(item?.assessmentId) ===
            convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID)
              ? ROMANTIC_COMPATIBILITY_REPORT_TYPE.PERSONALIZED
              : null,
          lastModifiedOn: item?.lastModifiedOn,
          assessmentCategoryName: item?.assessmentCategoryName,
        }))
      : [];

  // const userGivenAssessmentData = [...mappedData];
  let userGivenAssessmentData = [];

  if (romanticCompatibilityData?.length > 0 && mappedData.length > 0) {
    userGivenAssessmentData = [...romanticCompatibilityData, ...mappedData];
  } else if (romanticCompatibilityData?.length > 0) {
    userGivenAssessmentData = [...romanticCompatibilityData];
  } else {
    userGivenAssessmentData = [...mappedData];
  }
  userGivenAssessmentData = userGivenAssessmentData.sort(
    (a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime(),
  );

  // Filter only completed assessments (where personality is not null)
  const completedAssessments = userGivenAssessmentData.filter(
    (item) => item.personality !== null,
  );

  const selectedAssessment =
    userGivenAssessmentData.find(
      (item) => item.assessmentAttemptId === testPanelOpen,
    ) || completedAssessments[0];

  const traits = userAssessmentResult?.userTraits ?? [];

  const personalityType = userAssessmentResult
    ? userAssessmentResult?.personality?.title
    : "";
  const personalityGroup = userAssessmentResult
    ? userAssessmentResult?.personality?.role
    : "";
  const personalityName = userAssessmentResult
    ? userAssessmentResult?.personality?.name
    : "";
  const personalityNameEnglishCode = userAssessmentResult
    ? userAssessmentResult?.personality?.nameEnglishCode
    : "";

  const personalityImage = getImage(
    personalityGroup,
    personalityNameEnglishCode,
    false,
    gender || userData?.gender,
  );

  useEffect(() => {
    if (isAuth) {
      // createCookie("avatarImg", personalityImage, 1);
      dispatch(
        PushUserInformationToFunnelStep({
          avatarImg: personalityImage,
        }),
      );
    }
  }, [isAuth, personalityImage]);

  useEffect(() => {
    getBadgesConnect({ currentLocale }).then((res) => {
      setBadgesData(res);
    });
  }, [getBadgesConnect, currentLocale]);

  const tratiPercentage =
    traits &&
    traits?.map((item) => {
      return {
        ...item,
        percentage: item.percentage,
        leftTrait:
          item.percentage <= 50
            ? getPersonalityType(item?.trait?.title, t)
            : getOppositeTrait(item?.trait?.title, t),
        rightTrait:
          item.percentage > 50
            ? getPersonalityType(item?.trait?.title, t)
            : getOppositeTrait(item?.trait?.title, t),
        traitTitle: getPersonalityType(item?.trait?.title, t),
      };
    });

  useEffect(() => {
    getAssessmentByIdConnect(currentLocale).then((response) => {
      setAssessmentTitle(response);
      if (response && Array.isArray(response)) {
        setAllAssessments(response);

        // Use reusable function to group assessments
        const grouped = groupAndSortAssessments(response);

        // Convert to array format for TestCategoryCard
        const categoriesArray = Object.keys(grouped).map(
          (categoryName, index) => ({
            title: categoryName,
            items: grouped[categoryName]
              .map((assessment) => ({
                title: assessment?.assessmentTitle || assessment?.title || "",
                id: assessment.id,
              }))
              .filter((item) => item.title), // Only include items with titles
            originalIndex: index,
          }),
        );

        // Explicit priority ordering for category sections
        const categoryOrder = [
          "personality types",
          "mental health & neurodiversity",
          "relationships & social",
          "career & other",
        ];

        categoriesArray.sort((a, b) => {
          const aKey = a.title?.toLowerCase() ?? "";
          const bKey = b.title?.toLowerCase() ?? "";
          const aRank = categoryOrder.indexOf(aKey);
          const bRank = categoryOrder.indexOf(bKey);

          const aScore = aRank === -1 ? Number.MAX_SAFE_INTEGER : aRank;
          const bScore = bRank === -1 ? Number.MAX_SAFE_INTEGER : bRank;

          if (aScore !== bScore) return aScore - bScore;
          // fallback to original order to avoid unnecessary reshuffle
          return a.originalIndex - b.originalIndex;
        });

        setGroupedCategories(categoriesArray);
      }
    });
  }, [getAssessmentByIdConnect, currentLocale]);

  const completedAssessmentResult = assessmentAttemptData?.filter((item) => {
    return (
      item?.assessmentId === PERSONALITY_TEST_ASSESSMENT_ID &&
      item?.personality !== null
    );
  });

  const latestAssessmentAttemptId = completedAssessmentResult
    ?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)) // Sort by createdOn in descending order
    ?.map((item, index) => {
      if (index === 0) {
        return item.assessmentAttemptId; // Return the assessmentAttemptId of the first item
      }
    })
    ?.filter(Boolean)[0];

  const latestAssessmentId = completedAssessmentResult
    ?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)) // Sort by createdOn in descending order
    ?.map((item, index) => {
      if (index === 0) {
        return item.assessmentId; // Return the assessmentAttemptId of the first item
      }
    })
    ?.filter(Boolean)[0];

  const assessmentIcons = [
    { key: PERSONALITY_TEST_ASSESSMENT_ID, icon: PersonalityIcon },
    { key: CAREER_TEST_ASSESSMENT_ID, icon: CareerIcon },
    { key: CAREER_PREFERENCE_TEST_ASSESSMENT_ID, icon: CareerPreferenceIcon },
    {
      key: EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID,
      icon: EmotionalIntelligence,
    },
    // { key: "Relationship", icon: RelationShip },
    // { key: "Learning", icon: LearningStyle },
    // { key: "Stress", icon: StressManagement },
    { key: BIG_FIVE_FACETS_TEST_ASSESSMENT_ID, icon: BigFiveFacetsIcon },
    { key: BIG_FIVE_TEST_ASSESSMENT_ID, icon: BigFiveIcon },
    { key: ENNEAGRAM_TEST_ASSESSMENT_ID, icon: EnneagramIcon },
    { key: ADHD_TEST_ASSESSMENT_ID, icon: ADHDIcon },
    { key: DISC_TEST_ASSESSMENT_ID, icon: DiSCIcon },
    {
      key: PERSONALITY_DISORDER_TEST_ASSESSMENT_ID,
      icon: PersonalityDisorderIcon,
    },
    {
      key: LIKEABILITY_TEST_ASSESSMENT_ID,
      icon: LikeabilityIcon,
    },
    {
      key: DIFFICULT_PERSON_TEST_ASSESSMENT_ID,
      icon: DifficultIcon,
    },
    {
      key: NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID,
      icon: NarcissisticIcon,
    },
    {
      key: HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID,
      icon: HighlySensitiveIcon,
    },
    {
      key: AUTISM_SPECTRUM_TEST_ASSESSMENT_ID,
      icon: AutismIcom,
    },
    {
      key: ATTACHMENT_STYLE_TEST_ASSESSMENT_ID,
      icon: AttachmentStyleIcon,
    },
    {
      key: FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID,
      icon: FourTempermentsIcon,
    },
    {
      key: LOVE_STYLE_TEST_ASSESSMENT_ID,
      icon: LoveStyleIcon,
    },
    {
      key: ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID,
      icon: AntisocialIcon,
    },
    {
      key: DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID,
      icon: DyslexiaIcon,
    },
    {
      key: DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID,
      icon: DyslexiaIcon,
    },
    {
      key: ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
      icon: RomanticCompatibilityIcon,
    },
    {
      key: COLOR_BLINDNESS_TEST_ASSESSMENT_ID,
      icon: ColorBlindnessIcon,
    },
    {
      key: DEPRESSION_TEST_ASSESSMENT_ID,
      icon: DepressionIcon,
    },
    {
      key: BIPOLAR_DISORDER_ASSESSMENT_ID,
      icon: BipolarIcon,
    },
    {
      key: PSYCHOPATH_ASSESSMENT_ID,
      icon: PsychopathIcon,
    },
    {
      key: IQ_TEST_ASSESSMENT_ID,
      icon: IqIcon,
    },
    {
      key: CHILDHOOD_TRAUMA_TEST_ASSESSMENT_ID,
      icon: ChildhoodTraumaIcon,
    },
    {
      key: SOCIAL_ANXIETY_TEST_ASSESMENT_ID,
      icon: SocialAnxietyIcon,
    },
    {
      key: AUTISM_CHILDREN_TEST_ASSESSMENT_ID,
      icon: AutismChildIcon,
    },
    {
      key: SOCIOPATH_TEST_ASSESSMENT_ID,
      icon: SociopathIcon,
    },
  ];

  const assessmentOptions =
    assessmentTitle?.length &&
    [...assessmentTitle]
      .sort((a, b) => b.title.localeCompare(a.title)) //sorting the array in alphabetical order
      .map((item) => {
        const matchingIcon = assessmentIcons.find(
          (iconItem) =>
            item?.id.trim().toLowerCase() === iconItem.key.trim().toLowerCase(),
        );

        return {
          id: item.id,
          label: item.title,
          icon: matchingIcon ? matchingIcon.icon : PersonalityIcon, // Default to PersonalizedInsights if no match
          onClick: () => {
            const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
            navigate(`${path.next}?assessmentId=${item.id}&newt=true`);
            dispatch(PushAssessmentIdToFunnelStep(item.id));
            handleTestClick();
          },
        };
      });

  const getAllAssessmentData = useMemo(
    () =>
      (assessmentTitle?.length &&
        assessmentTitle
          .filter((item) => item.id !== COLOR_BLINDNESS_TEST_ASSESSMENT_ID)
          .map((item) => ({
            id: item.id,
            title: item.title,
          }))) ||
      [],
    [assessmentTitle],
  );
  const getAllAssessmentAttemptData =
    (assessmentAttemptData.length && [
      ...new Set(assessmentAttemptData?.map((item) => item.assessmentId)),
    ]) ||
    [];

  const notAttemptedAssessments = getAllAssessmentData.filter(
    (assessment) => !getAllAssessmentAttemptData.includes(assessment.id),
  );

  const handleTestClick = () => {
    dispatch(pushResetSelectedAnswerCountToFunnelStep());
    dispatch(PushAssessmentAttemptIdToFunnelStep(newAssessmentAttemptId));
    dispatch(PushQuizCompleteToFunnelStep(false));
    localStorage.removeItem("userAnswers");
  };

  const handleViewReportDashboard = () => {
    if (latestAssessmentAttemptId && isPremiumOrGuest) {
      const path = PathHelper(APP_NAVIGATION.PERSONALITY_REPORT, currentLocale);
      navigate(`${path.next}?aai=${latestAssessmentAttemptId}&uid=${userGUID}`); // for example
      // navigate(
      //   `${ROUTE_CONSTANT.PERSONALITY_REPORT}?aai=${latestAssessmentAttemptId}&uid=${userGUID}`
      // );
    } else {
      navigate(`${planPath.next}`); // for example
      // navigate(ROUTE_CONSTANT.PAYMENT_PLAN);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isLoading]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isLoading]);

  const handleViewReport = (
    isPremiumOrGuest,
    assessmentAttemptId,
    assessmentId,
    id,
    reportType = null,
  ) => {
    const isRomanticCompatibilityTest =
      convertToLowerCase(assessmentId) ===
      convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);
    let reportRoute;

    if (isRomanticCompatibilityTest) {
      const romanticRoutes = REPORT_ROUTES[assessmentId];
      if (reportType === ROMANTIC_COMPATIBILITY_REPORT_TYPE.PERSONALIZED) {
        reportRoute = romanticRoutes?.personal;
      } else {
        // Default to compatibility report (when reportType is "compatibility" or null)
        reportRoute = romanticRoutes?.compatibility;
      }
    } else {
      reportRoute = REPORT_ROUTES[assessmentId];
    }

    if (!reportRoute) {
      console.error(`No route found for assessmentId: ${assessmentId}`);
      return;
    }

    if (isPremiumOrGuest || isRomanticCompatibilityTest) {
      const path = PathHelper(reportRoute, locale);

      let queryParams = "";

      if (reportType === ROMANTIC_COMPATIBILITY_REPORT_TYPE.COMPATIBILITY) {
        // Only include assessresid for compatibility
        queryParams = `?assessresid=${id}`;
      } else {
        // Default case: include aai and uid
        queryParams = `?aai=${assessmentAttemptId}&uid=${userGUID}`;
      }

      navigate(`${path.next}${queryParams}`);
    } else {
      navigate(`${planPath.next}`);
    }
  };

  const handleRetakeTest = (item) => {
    handleTestClick();
    dispatch(PushAssessmentIdToFunnelStep(item.assessmentId));
    const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
    navigate(`${path.next}?assessmentId=${item.assessmentId}`);
  };

  const handleShareReport = (isPremiumOrGuest, item) => {
    if (isPremiumOrGuest) {
      setShareModalOpen(true);
      setSelectedTest(item);
      setPopoverOpen(false);
    } else {
      navigate(`${planPath.next}`); // for example
    }
  };

  const handleEmailReport = async (isPremiumOrGuest, data, item) => {
    if (!isPremiumOrGuest) {
      navigate(`${planPath.next}`); // for example
      return;
    }
    setPopoverOpen({});
    setTestPanelOpen(null);
    setIsButtonLoading(true);
    try {
      const emailResponse = await ShareReportOnEmailConnect(data);

      if (emailResponse.success) {
        toast.success(t("dashboard.report_sent_success_onemail_msg"));
      } else {
        const downloadResponse = await DownloadAssessmentResultConnect(
          userGUID,
          item.assessmentAttemptId,
          currentLocale !== LOCALE.EN && currentLocale,
        );

        if (downloadResponse) {
          const retryEmailResponse = await ShareReportOnEmailConnect(data);

          if (retryEmailResponse.success) {
            toast.success(t("dashboard.report_sent_success_onemail_msg"));
          } else {
            toast.error(t("dashboard.report_sent_fail_msg"));
          }
        }
      }
    } catch (error) {
      toast.error(t("dashboard.report_error_msg"));
    } finally {
      setIsButtonLoading(false);
    }
  };

  const handleSendToFriend = (isPremiumOrGuest, item) => {
    if (!isPremiumOrGuest) {
      navigate(`${planPath.next}`); // for example
    } else {
      setPopoverOpen({});
      setOpenSendToFriend(true);
      setSelectedAssessmentId(item?.assessmentId);
      setSelectedAssessmentAttemptId(item?.assessmentAttemptId);
      setSelectedResultId(item?.id);
      const reportType = item?.reportType;
      setSelectedReportType(reportType);
    }
  };

  const handleSendToPartner = (isPremiumOrGuest, item) => {
    setPopoverOpen({});
    setOpenSendToPartner(true);
    setSelectedAssessmentId(item?.assessmentId);
    setSelectedAssessmentAttemptId(item?.assessmentAttemptId);
    setSelectedAssessmentMaoId(item?.assessmentMapId);
  };

  const handleDeleteReport = (assessmentId, assessmentAttemptId, id) => {
    const data = {
      assessmentId,
      assessmentAttemptId,
      userGuid: userGUID,
      resultId: id,
    };

    DeleteReport(data).then((res) => {
      if (res.success) {
        toast.success(`${t("dashboard.report_delete_success_message")}`);
        getAssessmentAttemptByUserIdConnect(userGUID, currentLocale).then(
          (response) => {
            setAssessmentAttemptData(response);
          },
        );
        fetchUserAssessmentData();

        if (
          convertToLowerCase(assessmentId) ===
          convertToLowerCase(PERSONALITY_TEST_ASSESSMENT_ID)
        ) {
          const defaultImage = getImage(
            "",
            "",
            false,
            gender || userData?.gender,
          );
          dispatch(
            PushUserInformationToFunnelStep({
              avatarImg: defaultImage,
            }),
          );
          setUserAssessmentResult(null);
        }

        setPopoverOpen({});
      }
    });
  };

  // Handle delete click - shows confirmation modal
  const handleDeleteClick = (assessmentId, assessmentAttemptId, id) => {
    setDeleteConfirmParams({
      assessmentId,
      assessmentAttemptId,
      id,
    });
    setShowDeleteConfirmModal(true);
  };

  // Handle confirm delete - executes the delete after confirmation
  const handleConfirmDelete = () => {
    if (deleteConfirmParams) {
      handleDeleteReport(
        deleteConfirmParams.assessmentId,
        deleteConfirmParams.assessmentAttemptId,
        deleteConfirmParams.id,
      );
      setShowDeleteConfirmModal(false);
      setDeleteConfirmParams(null);
    }
  };

  // Handle close delete confirmation modal
  const handleCloseDeleteConfirm = () => {
    setShowDeleteConfirmModal(false);
    setDeleteConfirmParams(null);
  };

  const handleDownloadReport = async (
    isPremiumOrGuest,
    assessmentAttemptId,
  ) => {
    if (isPremiumOrGuest) {
      setIsButtonLoading(true);
      setPopoverOpen({});
      try {
        const res = await DownloadAssessmentResultConnect(
          userGUID,
          assessmentAttemptId,
          currentLocale !== LOCALE.EN && currentLocale,
        );
        if (res && res.hrefBlobUrl) {
          window.open(res.hrefBlobUrl, "_blank");
        } else {
          toast.error("Failed to download assessment result.");
        }
      } catch (error) {
        toast.error(
          "An error occurred while downloading the assessment result.",
        );
      } finally {
        setIsButtonLoading(false);
      }
    } else {
      navigate(`${planPath.next}`); // for example
    }
  };

  const toggleFilterPanel = () => {
    setIsFilterPanelOpen(!isFilterPanelOpen);
  };

  const personalityColorDark = getColorCode(
    personalityGroup && personalityGroup,
  ).dark;
  const personalityColorLight = getColorCode(
    personalityGroup && personalityGroup,
  ).light;

  const personalityColorMedium = getColorCode(
    personalityGroup && personalityGroup,
  ).medium;

  const bannerImage = getBannerImage(personalityGroup);

  const scrollAndHighlightElement = (elementId, duration = 2000) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      // Add temporary highlight class
      element.classList.add("ring", "ring-[#805AED]", "ring-opacity-100");
      // Remove highlight after animation
      setTimeout(() => {
        element.classList.remove("ring", "ring-[#805AED]", "ring-opacity-100");
      }, duration);
    }
  };

  useEffect(() => {
    if (userGUID) {
      GetUserByIdConnect(userGUID).then((res) => {
        if (res) {
          setUserData(res);
          const fullName =
            [res?.firstName, res?.lastName]
              .filter((name) => name && name.trim().length > 0)
              .join(" ") || res?.userName;
          dispatch(
            PushUserInformationToFunnelStep({
              uname: fullName,
              accnum: res?.accountNumber,
            }),
          );
          // createCookie("userguid", res?.userGuid, 1);
          // createCookie("uname", fullName, 1);
          // createCookie("accnum", res?.accountNumber, 1);
          if (res.parentUserGuid && res?.parentUserGuid !== Guid.EMPTY) {
            dispatch(PushGuestUserToFunnelStep(true));
          }
        }
      });

      GetGuestUserConnect(userGUID).then((res) => {
        if (res) {
          const filteredData = res.filter(
            (item) =>
              item.invitationStatus === InvitationStatus.Sent ||
              item?.invitationStatus === InvitationStatus.Accepted,
          );
          const nonRemovedInvitations = res.filter(
            (item) => item.invitationStatus !== InvitationStatus.Removed,
          );
          setGuestUserCount(filteredData.length);
          setGuestUserData(nonRemovedInvitations);
          // createCookie("guestUserCount", filteredData.length, 1);
        }
      });
    }
  }, [userGUID]);

  useEffect(() => {
    if (transactionDetails && transactionDetails?.transactionDetailId) {
      let skuGuid = selectedPlan?.id;
      if (!skuGuid) {
        skuGuid = skuId;
      }
      const data = {
        skuGuid: skuGuid,
        transId: transactionDetails?.transactionDetailId,
        locale: "en",
      };
      GetBillingConnect(data).then((res) => {
        setBillingDetails(res);
        if (res && res.maxSubUserCount !== undefined) {
          PushUserInformationToFunnelStep({
            maxSubUserCount: res.maxSubUserCount,
          });
          // createCookie("maxSubUserCount", res.maxSubUserCount, 1);
        }
        if (res) {
          dispatch(
            PushBillingDetails({
              nextBillingDate: res.nextBillingDate ?? "",
            }),
          );
        }
      });
    }
  }, [transactionDetails]);

  const fetchSocialShareCount = useCallback(() => {
    if (userGUID) {
      getUserSocialButtonClickByUserIdConnect(userGUID).then((res) => {
        if (res?.totalClickCount) {
          setTotalUserSocialShareCount(res?.totalClickCount);
        }
      });
    }
  }, [userGUID, getUserSocialButtonClickByUserIdConnect]);

  useEffect(() => {
    fetchSocialShareCount();
  }, [fetchSocialShareCount]);

  // useEffect(() => {
  //   if (
  //     selectedAssessment?.assessmentId ===
  //       ROMANTIC_COMPATIBILITY_ASSESSMENT_ID &&
  //     selectedAssessment?.assessmentMapId
  //   ) {
  //     checkRomanticCompatibilityStatus(selectedAssessment.assessmentMapId);
  //   }
  // }, [selectedAssessment?.assessmentMapId, selectedAssessment?.assessmentId]);

  // const checkRomanticCompatibilityStatus = (assessmentMapId) => {
  //   if (!assessmentMapId) return false;

  //   if (romanticCompatibilityStatus[assessmentMapId] !== undefined) {
  //     return romanticCompatibilityStatus[assessmentMapId];
  //   }

  //   // Only make API call if not already in progress
  //   if (!romanticCompatibilityStatus[`${assessmentMapId}_loading`]) {
  //     // Mark as loading to prevent duplicate calls
  //     setRomanticCompatibilityStatus((prev) => ({
  //       ...prev,
  //       [`${assessmentMapId}_loading`]: true,
  //     }));

  //     isCompleteRomanticCompatibilityConnect(assessmentMapId)
  //       .then((response) => {
  //         setRomanticCompatibilityStatus((prev) => ({
  //           ...prev,
  //           [assessmentMapId]: response || false,
  //           [`${assessmentMapId}_loading`]: false,
  //         }));
  //       })
  //       .catch((error) => {
  //         console.error(
  //           "Error checking romantic compatibility completion:",
  //           error
  //         );
  //         setRomanticCompatibilityStatus((prev) => ({
  //           ...prev,
  //           [assessmentMapId]: false,
  //           [`${assessmentMapId}_loading`]: false,
  //         }));
  //       });
  //   }

  //   return false;
  // };

  const handleStartAssessment = (assessmentId) => {
    const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
    navigate(`${path.next}?assessmentId=${assessmentId}&newt=true`);
    dispatch(PushAssessmentIdToFunnelStep(assessmentId));
    handleTestClick();
  };

  const handleContinueTest = (assessmentId, assessmentAttemptId) => {
    dispatch(PushAssessmentAttemptIdToFunnelStep(assessmentAttemptId));
    dispatch(PushQuizCompleteToFunnelStep(false));
    dispatch(PushBackClickCountToFunnelStep(0));
    dispatch(PushAssessmentIdToFunnelStep(assessmentId));
    const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
    navigate(
      `${path.next}?assessmentId=${assessmentId}&assessmentAttemptId=${assessmentAttemptId}`,
    );
    setTestPanelOpen(null);
  };

  const isParentUser = userData && userData?.parentUserGuid === Guid.EMPTY;
  const shouldHideAssessments = assessmentAttemptData.length === 0;

  useEffect(() => {
    // const guestUserCountValue = guestUserCount;
    const maxSubUserCount = billingDetails?.maxSubUserCount;

    // Store values in cookies
    // if (guestUserCountValue !== undefined) {
    //   createCookie("guestUserCount", guestUserCountValue, 1);
    // }
    if (maxSubUserCount !== undefined) {
      // createCookie("maxSubUserCount", maxSubUserCount, 1);
      PushUserInformationToFunnelStep({
        maxSubUserCount: maxSubUserCount,
      });
    }
  }, [guestUserCount, billingDetails?.maxSubUserCount]);

  const getMobileActions = () => {
    const isComplete = selectedAssessment?.personality !== null;
    const reportType = selectedAssessment?.reportType;

    if (!isComplete) {
      return [
        {
          label: `${t("dashboard.continue_test")}`,
          icon: PlayIcon,
          onClick: () =>
            handleContinueTest(
              selectedAssessment.assessmentId,
              selectedAssessment.assessmentAttemptId,
            ),
        },
      ];
    }

    const baseActions = [
      {
        label: `${t("dashboard.view_report_cta")}`,
        icon: ViewReportIcon,
        onClick: () => {
          handleViewReport(
            isPremiumOrGuest,
            selectedAssessment?.assessmentAttemptId,
            selectedAssessment?.assessmentId,
            selectedAssessment?.id,
            reportType,
          );
          setTestPanelOpen(null);
        },
      },
      {
        label: `${t("dashboard.retake_test")}`,
        icon: RetakeTestIcon,
        onClick: () => {
          handleRetakeTest(selectedAssessment);
          setTestPanelOpen(null);
        },
      },
      { type: "divider" },
      {
        label: `${t("dashboard.share_report")}`,
        icon: ShareReportIcon,
        onClick: () => handleShareReport(isPremiumOrGuest, selectedAssessment),
      },
      {
        label: `${t("dashboard.send_to_friend")}`,
        icon: SendToFriendIcon,
        onClick: () => handleSendToFriend(isPremiumOrGuest, selectedAssessment),
      },
    ];

    // Hide standard View Report for RomanticCompatibilityTest
    const commonActions = baseActions;

    const deleteAction = {
      label: `${t("dashboard.delete_report")}`,
      icon: DeleteReportIcon,
      onClick: () => {
        handleDeleteClick(
          selectedAssessment.assessmentId,
          selectedAssessment.assessmentAttemptId,
          selectedAssessment.id,
        );
        setTestPanelOpen(null);
      },
      className: "text-red-500",
    };

    const extraActions = {
      [PERSONALITY_TEST_ASSESSMENT_ID]: [
        {
          label: `${t("dashboard.download_report")}`,
          icon: DownloadReportIcon,
          onClick: () => {
            handleDownloadReport(
              isPremiumOrGuest,
              selectedAssessment.assessmentAttemptId,
            );
            setTestPanelOpen(null);
          },
        },
        {
          label: `${t("dashboard.email_report")}`,
          icon: EmailReportIcon,
          onClick: () => {
            handleEmailReport(
              isPremiumOrGuest,
              {
                userGuid: userGUID,
                assessmentAttemptId: selectedAssessment.assessmentAttemptId,
                locale: currentLocale,
              },
              selectedAssessment,
            );
          },
        },
        { type: "divider" },
      ],
      [ROMANTIC_COMPATIBILITY_ASSESSMENT_ID]: [
        // {
        //   label: "Personalized Report",
        //   icon: ViewReportIcon,
        //   onClick: () => {
        //     handleViewReport(
        //       isPremiumOrGuest,
        //       selectedAssessment?.assessmentAttemptId,
        //       selectedAssessment?.assessmentId,
        //       "personal"
        //     );
        //     setTestPanelOpen(null);
        //   },
        // },
        // ...(checkRomanticCompatibilityStatus(
        //   selectedAssessment?.assessmentMapId
        // )
        //   ? [
        //       {
        //         label: "Compatibility Report",
        //         icon: ViewReportIcon,
        //         onClick: () => {
        //           handleViewReport(
        //             isPremiumOrGuest,
        //             selectedAssessment?.assessmentAttemptId,
        //             selectedAssessment?.assessmentId,
        //             "compatibility"
        //           );
        //           setTestPanelOpen(null);
        //         },
        //       },
        //     ]
        //   : []),
        ...(isParentUser
          ? [
              {
                label: `${t("dashboard.send_to_partner")}`,
                icon: DownloadReportIcon,
                onClick: () => {
                  handleSendToPartner(isPremiumOrGuest, selectedAssessment);
                  setTestPanelOpen(null);
                },
              },
            ]
          : []),
        { type: "divider" },
      ],
    };

    const defaultActions = [
      ...commonActions,
      { type: "divider" },
      deleteAction,
    ];

    return [
      ...(extraActions[selectedAssessment?.assessmentId] || []),
      ...defaultActions,
    ];
  };

  const filteredData = userGivenAssessmentData.filter((item) => {
    if (currentFilter === "All") return true;
    return item.assessmentId === currentFilter; // Compare with assessmentId
  });

  const completedAsssessmentData = userGivenAssessmentData.filter((item) => {
    return item.personality !== null;
  });

  const completedAssessmentCount = getUniqueAssessmentCompletedCount(
    completedAsssessmentData,
  );

  const isAttemptUserAllAssessments = checkUserAttemptAllAssessments(
    completedAssessmentCount,
    allAssessments.length,
  );

  const badgeCompletedCount = useMemo(() => {
    if (!badgesData || badgesData.length === 0) return 0;
    const completedQuizCount =
      assessmentAttemptData?.filter((item) => item.personality !== null)
        .length || 0;
    const inviteCount = guestUserData?.length || 0;
    const socialShareCount = totalUserSocialShareCount;
    return badgesData.filter((badge) => {
      if (badge.badgeType === BADGE_TYPE.TEST_COMPLETION)
        return completedQuizCount >= badge.threshold;
      if (badge.badgeType === BADGE_TYPE.INVITE)
        return inviteCount >= badge.threshold;
      if (badge.badgeType === BADGE_TYPE.SOCIAL_SHARE)
        return socialShareCount >= badge.threshold;
      return false;
    }).length;
  }, [
    badgesData,
    assessmentAttemptData,
    guestUserData,
    totalUserSocialShareCount,
  ]);

  useEffect(() => {
    dispatch(PushCompletedAchievements(badgeCompletedCount));
  }, [badgeCompletedCount]);

  const handleNavigateCurrentFilterTest = (assessmentId) => {
    if (currentFilter === "All") {
      // navigate(
      //   `${ROUTE_CONSTANT.QUIZ}?assessmentId=${PERSONALITY_TEST_ASSESSMENT_ID}&newt=true`
      // );
      const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
      navigate(
        `${path.next}?assessmentId=${PERSONALITY_TEST_ASSESSMENT_ID}&newt=true`,
      ); // for example
      // scrollAndHighlightElement("new-test-button");
      // setOpenNewTest(true);
    } else {
      const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
      navigate(`${path.next}?assessmentId=${assessmentId}&newt=true`);
      // navigate(`${ROUTE_CONSTANT.QUIZ}?assessmentId=${assessmentId}&newt=true`);
    }
  };

  const assessmentFilterOption =
    assessmentTitle?.length &&
    assessmentTitle?.map((item) => {
      const matchingIcon = assessmentIcons.find(
        (iconItem) =>
          item?.id.trim().toLowerCase() === iconItem.key.trim().toLowerCase(),
      );
      return {
        title: item?.title,
        id: item?.id,
        icon: matchingIcon ? matchingIcon.icon : PersonalityIcon,
      };
    });

  const attemptAssessmentIds = useMemo(() => {
    if (!assessmentAttemptData?.length) return []; // Handle empty case

    // Extract IDs and remove duplicates using Set
    const uniqueIds = [
      ...new Set(assessmentAttemptData.map((item) => item.assessmentId)),
    ];

    return uniqueIds;
  }, [assessmentAttemptData]); // Recompute only if assessmentAttemptData changes
  const settingsPath = PathHelper(APP_NAVIGATION.SETTINGS, currentLocale);
  const planPath = PathHelper(APP_NAVIGATION.PLAN, currentLocale);

  // Color utility to get Tailwind colors dynamically
  const getTailwindColor = (colorName) => {
    const colors = {
      "insightful-pink": "#E61A9B",
      "insightful-dark-green": "#53AF65",
      "insightful-blue": "#1D95FF",
    };
    return colors[colorName] || "#000000";
  };

  // Reusable invite friend function
  const handleInviteFriend = () => {
    if (isPremiumOrGuest) {
      if (guestUserCount < billingDetails?.maxSubUserCount) {
        setOpenCreateUser(true);
      } else {
        toast.warning(String(t("settings.max_user_reached_msg")));
      }
    } else {
      const path = PathHelper(APP_NAVIGATION.PLAN, currentLocale);
      navigate(`${path.next}`);
    }
  };

  // Reusable take random quiz function
  const handleTakeRandomQuiz = () => {
    if (assessmentOptions && assessmentOptions.length > 0) {
      const randomOption =
        assessmentOptions[Math.floor(Math.random() * assessmentOptions.length)];
      randomOption.onClick();
    }
  };

  const handleOpenCompletedAssessment = () => {
    setShowCompleteAssessmentsOnly(true);
  };

  /// Cards
  const AchievementsCard = ({
    expandedAchievement,
    setExpandedAchievement,
    openedAssessmentAchievement,
    setOpenedAssessmentAchievement,
  }) => {
    const [showAllAchievements, setShowAllAchievements] = useState(false);

    const achievementsContainerRef = useRef(null);

    // Optimized smooth auto-scroll function for share results
    const triggerAutoScroll = () => {
      // Use requestAnimationFrame to wait for DOM update, then setTimeout for table render
      requestAnimationFrame(() => {
        setTimeout(() => {
          // Try multiple ways to find the container
          let container = achievementsContainerRef.current;

          if (!container) {
            // Fallback: find container by class name
            container = document.querySelector(
              ".flex-1.px-4.overflow-y-auto.max-h-80.scrollbar-hide",
            );
          }

          if (!container) {
            // Another fallback: find the achievements card container
            const achievementsCard =
              document.getElementById("achievements-card");
            if (achievementsCard) {
              container = achievementsCard.querySelector(".overflow-y-auto");
            }
          }

          if (!container) {
            return;
          }

          const canScroll = container.scrollHeight > container.clientHeight;

          if (canScroll) {
            const originalPosition = container.scrollTop;
            const targetPosition =
              container.scrollHeight - container.clientHeight;

            // Custom smooth scroll with slower, more elegant animation
            const smoothScroll = (element, target, duration = 1200) => {
              const start = element.scrollTop;
              const distance = target - start;
              const startTime = performance.now();

              // More elegant easing function (ease-in-out-cubic)
              const easeInOutCubic = (t) => {
                return t < 0.5
                  ? 4 * t * t * t
                  : 1 - Math.pow(-2 * t + 2, 3) / 2;
              };

              const animateScroll = (currentTime) => {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easedProgress = easeInOutCubic(progress);

                element.scrollTop = start + distance * easedProgress;

                if (progress < 1) {
                  requestAnimationFrame(animateScroll);
                }
              };

              requestAnimationFrame(animateScroll);
            };

            // Scroll to bottom with slower animation
            smoothScroll(container, targetPosition, 1200);

            // Wait longer before scrolling back for better user experience
            setTimeout(() => {
              smoothScroll(container, originalPosition, 1200);
            }, 1500);
          }
        }, 400); // Slightly longer delay for table render
      });
    };

    // Calculate user progress
    const completedQuizCount =
      assessmentAttemptData?.filter((item) => item.personality !== null)
        .length || 0;

    const inviteCount = guestUserData?.length || 0;
    const socialShareCount = totalUserSocialShareCount;

    // Generate achievements from badges data
    const achievements = useMemo(() => {
      if (!badgesData || badgesData.length === 0) return [];

      const achievementsList = [];

      // Group badges by type and sort by level
      const testBadges = badgesData
        .filter((badge) => badge.badgeType === BADGE_TYPE.TEST_COMPLETION)
        .sort((a, b) => a.level - b.level);

      const inviteBadges = badgesData
        .filter((badge) => badge.badgeType === BADGE_TYPE.INVITE)
        .sort((a, b) => a.level - b.level);

      const socialBadges = badgesData
        .filter((badge) => badge.badgeType === BADGE_TYPE.SOCIAL_SHARE)
        .sort((a, b) => a.level - b.level);

      // Process test completion achievements
      testBadges.forEach((badge) => {
        const isCompleted = completedQuizCount >= badge.threshold;
        const progress = Math.min(completedQuizCount, badge.threshold);

        achievementsList.push({
          id: badge.id,
          badgeType: badge.badgeType,
          level: badge.level,
          title: badge.title,
          progress: progress,
          total: badge.threshold,
          color: getTailwindColor("insightful-pink"),
          icon: getAchievementIcon(badge.iconUrl),
          description: t(
            "dashboard-b.achievements.quiz_completion_description",
            {
              threshold: badge.threshold,
              plural: badge.threshold > 1 ? "s" : "",
            },
          ),
          category: t("dashboard-b.achievements.category_quiz"),
          categoryAction: t("dashboard-b.achievements.quiz_cta"),
          completed: isCompleted,
          onAction: handleTakeRandomQuiz,
        });
      });

      // Process invite achievements
      inviteBadges.forEach((badge) => {
        const isCompleted = inviteCount >= badge.threshold;
        const progress = Math.min(inviteCount, badge.threshold);

        achievementsList.push({
          id: badge.id,
          badgeType: badge.badgeType,
          level: badge.level,
          title: badge.title,
          progress: progress,
          total: badge.threshold,
          color: getTailwindColor("insightful-dark-green"),
          icon: getAchievementIcon(badge.iconUrl),
          description: t("dashboard-b.achievements.invite_friend_description", {
            threshold: badge.threshold,
            plural: badge.threshold > 1 ? "s" : "",
          }),
          category: t("dashboard-b.achievements.category_invite"),
          categoryAction: t("dashboard-b.achievements.invite_cta"),
          completed: isCompleted,
          onAction: handleInviteFriend,
        });
      });

      // Process social share achievements
      socialBadges.forEach((badge) => {
        const isCompleted = socialShareCount >= badge.threshold;
        const progress = Math.min(socialShareCount, badge.threshold);

        achievementsList.push({
          id: badge.id,
          badgeType: badge.badgeType,
          level: badge.level,
          title: badge.title,
          progress: progress,
          total: badge.threshold,
          color: getTailwindColor("insightful-blue"),
          icon: getAchievementIcon(badge.iconUrl),
          description: t("dashboard-b.achievements.share_results_description", {
            threshold: badge.threshold,
            plural: badge.threshold > 1 ? "s" : "",
          }),
          category: t("dashboard-b.achievements.category_share"),
          categoryAction: t("dashboard-b.achievements.share_cta"),
          completed: isCompleted,
        });
      });

      return achievementsList;
    }, [completedQuizCount, inviteCount, socialShareCount, badgesData]);

    const completedAchievements = achievements.filter((a) => a.completed);
    const inProgressAchievements = achievements.filter((a) => !a.completed);

    // Filter achievements to show based on requirements
    const getDisplayedAchievements = () => {
      // Always show only one of each type in progress
      const filteredInProgress = [];

      const quizInProgress = inProgressAchievements.find(
        (a) => a.badgeType === BADGE_TYPE.TEST_COMPLETION,
      );
      const inviteInProgress = inProgressAchievements.find(
        (a) => a.badgeType === BADGE_TYPE.INVITE,
      );
      const socialShareInProgress = inProgressAchievements.find(
        (a) => a.badgeType === BADGE_TYPE.SOCIAL_SHARE,
      );

      if (quizInProgress) filteredInProgress.push(quizInProgress);
      if (inviteInProgress) filteredInProgress.push(inviteInProgress);
      if (socialShareInProgress) filteredInProgress.push(socialShareInProgress);
      const shouldShowCompletedEarly = filteredInProgress.length <= 2;

      if (showAllAchievements) {
        return {
          inProgress: filteredInProgress,
          completed: completedAchievements,
        };
      }

      return {
        inProgress: filteredInProgress,
        completed: shouldShowCompletedEarly
          ? completedAchievements.slice(0, 2) // show only few
          : [],
      };
    };

    const displayedAchievements = getDisplayedAchievements();

    const toggleExpanded = (id) => {
      // close table when collapsing
      if (expandedAchievement === id) {
        setExpandedAchievement(null);
        setOpenedAssessmentAchievement(null);
      } else {
        setExpandedAchievement(id);
        setOpenedAssessmentAchievement(null);
      }
    };

    const smoothScrollTo = (element, target, duration = 600) => {
      const start = element.scrollTop;
      const distance = target - start;
      const startTime = performance.now();

      const easeInOut = (t) =>
        t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;

      const step = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = easeInOut(progress);

        element.scrollTop = start + distance * eased;

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    };

    // Auto-scroll achievements when View All is clicked (showAllAchievements = true)
    useEffect(() => {
      if (showAllAchievements && achievementsContainerRef.current) {
        const container = achievementsContainerRef.current;
        let rafId;
        let downTimeout;
        let upTimeout;

        const originalPosition = container.scrollTop;

        downTimeout = setTimeout(() => {
          // Scroll to bottom
          smoothScrollTo(
            container,
            container.scrollHeight - container.clientHeight,
            700,
          );

          upTimeout = setTimeout(() => {
            smoothScrollTo(container, originalPosition, 700);
          }, 800);
        }, 200);

        return () => {
          if (rafId) cancelAnimationFrame(rafId);
          if (downTimeout) clearTimeout(downTimeout);
          if (upTimeout) clearTimeout(upTimeout);
        };
      }
    }, [showAllAchievements]);

    const AchievementItem = ({ achievement }) => {
      const isExpanded = expandedAchievement === achievement.id;
      const showTable = openedAssessmentAchievement === achievement.id;
      const progressPercentage =
        (achievement.progress / achievement.total) * 100;

      const tableRef = useRef(null);

      return (
        <div
          className={`rounded-xl p-2 mb-3 transition-all duration-200 ${
            achievement.completed
              ? "bg-insightful-light-green border border-green-200"
              : "bg-insightful-lightest-purple border border-purple-100"
          }`}
        >
          <div
            className={`flex items-center justify-between ${
              !achievement.completed ? "cursor-pointer" : "cursor-default"
            }`}
            onClick={() =>
              !achievement.completed && toggleExpanded(achievement.id)
            }
          >
            <div className="flex items-center flex-1">
              <div className="w-12 h-12 mr-4">
                <img
                  src={achievement.icon}
                  alt={achievement.title}
                  className="h-full w-full rounded-full object-cover"
                />
              </div>

              <div className="flex-1">
                <h3 className="font-semibold text-[13px] text-left px-2 py-1">
                  {achievement.title}
                </h3>

                <div className="flex items-center gap-2 mt-2">
                  <div className="w-full rounded-full h-2 bg-[#F8F8F8] flex items-center">
                    <div
                      className="h-2 rounded-full transition-all duration-300"
                      style={{
                        width: `${progressPercentage}%`,
                        backgroundColor: achievement.color,
                      }}
                    />
                  </div>
                  <span className="text-xs text-black">
                    {achievement.progress}/{achievement.total}
                  </span>
                </div>
              </div>
            </div>

            <button className="text-4xl">&#x22EE;</button>
          </div>

          {isExpanded && (
            <div
              className="mt-4 pt-4 border-t border-gray-200 rounded-b-lg px-2 py-3 -mx-2 -mb-2 "
              style={{ backgroundColor: "#E7E7FF" }}
            >
              {achievement.category && (
                <div className="flex flex-col gap-2">
                  {/* Category */}
                  <span className="text-xs text-purple-600 font-medium text-left">
                    {achievement.category}
                  </span>

                  {/* Description + Button */}
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
                    <span className="text-xs text-gray-600 leading-5 flex-1 text-left">
                      {achievement.description}
                    </span>

                    {achievement.categoryAction && !achievement.completed && (
                      <button
                        className={`px-3 py-2 text-xs font-bold rounded-full whitespace-normal text-center w-full sm:w-auto ${
                          achievement.badgeType === BADGE_TYPE.SOCIAL_SHARE &&
                          completedAsssessmentData.length === 0
                            ? "bg-gray-400 cursor-not-allowed text-gray-200"
                            : "bg-purple-600 text-white hover:bg-purple-700 transition-colors"
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();

                          if (
                            achievement.badgeType === BADGE_TYPE.SOCIAL_SHARE
                          ) {
                            // Set the state first
                            setOpenedAssessmentAchievement(
                              showTable ? null : achievement.id,
                            );

                            // Trigger smooth auto-scroll when opening the table
                            if (!showTable) {
                              triggerAutoScroll();
                            }
                          } else if (achievement.onAction) {
                            achievement.onAction();
                          }
                        }}
                        disabled={
                          achievement.badgeType === BADGE_TYPE.SOCIAL_SHARE &&
                          completedAsssessmentData.length === 0
                        }
                      >
                        {achievement.categoryAction}
                      </button>
                    )}
                  </div>
                </div>
              )}
              {/*TABLE INSIDE SAME EXPANDED AREA */}
              {showTable && (
                <div ref={tableRef} className="mt-4">
                  {" "}
                  <CompletedAssessments
                    completedAsssessmentData={completedAsssessmentData}
                    t={t}
                    gender={gender}
                    personalityNameEnglishCode={personalityNameEnglishCode}
                    personalityGroup={personalityGroup}
                    isPremiumOrGuest={isPremiumOrGuest}
                    handleShareReport={handleShareReport}
                    convertToLowerCase={convertToLowerCase}
                    personalityNamesAndGroups={personalityNamesAndGroups}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      );
    };

    return (
      <div className="h-full">
        <div className="rounded-2xl shadow-md border h-full flex flex-col pt-6 pb-6 border-insightful-blue bg-F8F8F8">
          {/* Header */}
          <div className="text-center mb-6 px-4">
            <div className="text-[#805AED] font-semibold text-[13px] mb-4">
              {t("dashboard-b.achievements.achievements")}
            </div>

            <div className="text-black font-semibold text-xl mb-2">
              <span
                dangerouslySetInnerHTML={{
                  __html: t("dashboard-b.achievements.completed_tests", {
                    completed: `<span class="text-[#805AED]">${completedAchievements.length}</span>`,
                    total: achievements.length,
                  }),
                }}
              />
            </div>

            <p className="text-gray-600 text-sm">
              {t("dashboard-b.achievements.description")}
            </p>
          </div>

          {/*In Progress Achievements */}
          <div
            ref={achievementsContainerRef}
            className={`flex-1 px-4 max-h-80 scrollbar-hide transition-all duration-300 ${
              showAllAchievements
                ? "overflow-y-auto"
                : "overflow-y-auto md:pointer-events-auto"
            }`}
          >
            <div className="mb-6">
              {displayedAchievements.inProgress.map((achievement) => (
                <AchievementItem
                  key={achievement.id}
                  achievement={achievement}
                />
              ))}
            </div>

            {/* Completed Challenges */}
            {displayedAchievements.completed.length > 0 && (
              <div>
                <h3 className="text-gray-700 font-semibold text-center mb-4">
                  {t("dashboard-b.achievements.completed_challenges")}
                </h3>

                {displayedAchievements.completed.map((achievement) => (
                  <AchievementItem
                    key={achievement.id}
                    achievement={achievement}
                  />
                ))}
              </div>
            )}
          </div>

          {completedAchievements.length > 0 && (
            <button
              onClick={() => {
                setShowAllAchievements(!showAllAchievements);
                setExpandedAchievement(null);
                setOpenedAssessmentAchievement(null);
              }}
              className="text-center mt-4 text-insightful-purple font-medium text-sm underline cursor-pointer"
            >
              {showAllAchievements
                ? t("dashboard-b.achievements.show_less")
                : t("dashboard-b.achievements.view_all")}
            </button>
          )}
        </div>
      </div>
    );
  };

  const InviteCard = ({
    title,
    cupsImage,
    description,
    highlightText,
    highlightColor,
    subText,
    subtexthighlight,
    subtexthighlightcolor,
    subTextColor = "#000000",
    buttonText,
    buttonWidth = "100%",
    buttonColor,
    manageText,
    manageColor,
    textColor = "#000000",
    background,
    nextLevelText,
    nextLevelHighlight,
    nextLevelColor = "#000000",
    onButtonClick,
    onManageClick,
  }) => {
    // Highlight inside description (e.g., 25%)
    const highlightedDescription = description?.replace(
      new RegExp(`(${highlightText})`, "g"),
      `<span style="color:${highlightColor}; font-weight:600;">$1</span>`,
    );

    // Highlight inside subText (optional)
    const highlightedSubText =
      subText &&
      subText?.replace(
        subtexthighlight ? new RegExp(`(${subtexthighlight})`, "g") : /$^/, // match nothing if highlight not given
        `<span style="color:${subtexthighlightcolor}; font-weight:600;">$1</span>`,
      );
    // NEW: highlight inside Next Level text
    const highlightedNextLevel = nextLevelText?.replace(
      nextLevelHighlight ? new RegExp(`(${nextLevelHighlight})`, "g") : /$^/,
      `<span style="color:${highlightColor}; font-weight:600;">$1</span>`,
    );

    return (
      <div className="h-full">
        <div
          className="shadow-md border-[1px] rounded-[20px] h-full flex flex-col
               pt-4 md:pt-6 pb-4 md:pb-6  items-center justify-center border-insightful-blue"
        >
          {/* Title */}
          {title && (
            <div
              className="text-center font-semibold text-[13px] mb-5"
              style={{ color: highlightColor }}
            >
              {title}
            </div>
          )}

          {/* Optional Image */}
          {cupsImage && (
            <div className="flex justify-center mb-5">
              <img
                src={cupsImage}
                alt="trophies"
                className="h-10 object-contain"
              />
            </div>
          )}

          {/* Description (with highlightText replaced) */}
          {description && (
            <p
              className="text-center text-base px-5 mb-5 font-semibold leading-5"
              style={{ color: textColor, fontSize: "20px" }}
              dangerouslySetInnerHTML={{ __html: highlightedDescription }}
            />
          )}

          {/* NEW — Next Level Text */}
          {nextLevelText && (
            <p
              className="text-center text-sm mb-4"
              style={{ color: nextLevelColor, opacity: 0.9 }}
              dangerouslySetInnerHTML={{ __html: highlightedNextLevel }}
            />
          )}

          {/* Subtext (only highlighted word colored, rest normal) */}
          {subText && (
            <p
              className="text-xs font-[Montserrat] text-center px-5 mb-5"
              style={{ color: subTextColor, fontSize: "16px", opacity: 0.9 }}
              dangerouslySetInnerHTML={{ __html: highlightedSubText }}
            />
          )}

          {/* Button */}
          {buttonText && (
            <button
              className={`mt-5 rounded-full font-bold text-white mx-auto block
      px-4 py-3 text-center
      whitespace-normal break-words leading-tight
      text-[14px] sm:text-[16px]
      ${buttonWidth === "80%" ? "w-[80%]" : "w-[75%]"}`}
              style={{ background: buttonColor }}
              onClick={onButtonClick}
            >
              {buttonText}
            </button>
          )}

          {/* Bottom Text */}
          {manageText && (
            <p
              className="text-center text-sm mt-5 px-4 font-medium cursor-pointer"
              style={{
                color: manageColor,
                textDecoration: "underline",
                textUnderlineOffset: "3px",
              }}
              onClick={onManageClick}
            >
              {manageText}
            </p>
          )}
        </div>
      </div>
    );
  };

  const assessmentAttemptStatuses =
    getAssessmentStatuses(assessmentAttemptData) || [];

  return (
    <div className="">
      <Header personalityImage={personalityImage} />
      {isButtonLoading || isLoading || isUserAssessmentResulMapDataLoading ? (
        <Loader
          isLoading={
            isButtonLoading || isLoading || isUserAssessmentResulMapDataLoading
          }
        />
      ) : (
        <div className="w-full">
          <div
            className="mx-auto text-center flex-col relative md:mt-[10px] pb-[25vh] md:pb-[20vh] lg:pb-0"
            style={{ backgroundColor: "#F8F8F8" }}
          >
            {/* ------------------------------------TOP SECTION QUIZ------------------------------------ */}
            <div className="w-full mx-auto p-[15px] flex items-center ">
              {notAttemptedAssessments.length === 0 ? (
                <div
                  className="min-w-[300px] w-full max-h-full rounded-[20px] shadow-lg flex items-center bg-cover bg-center relative 
                              px-[15px] pt-[5px] pb-[5px] lg:px-[15px] lg:pt-[10px] lg:pb-[5px]"
                  style={{
                    backgroundImage: bannerImage
                      ? `url(${bannerImage})`
                      : "none",
                    backgroundColor: "#E1E1FF", // Fallback background color
                  }}
                >
                  <img
                    src={personalityImage} // Add a default image path
                    alt="Dashboard Avatar"
                    className="hidden md:block h-72 w-auto max-w-full max-h-full
                    object-contain object-center aspect-square "
                    onError={(e) => {
                      e.target.src = "/default-avatar.png"; // Fallback on image load error
                    }}
                  />

                  <img
                    src={personalityImage || "/default-avatar.png"} // Add a default image path
                    alt="Dashboard Avatar"
                    className="md:hidden max-h-full w-[140px] h-auto mr-2 pt-[10px]"
                    onError={(e) => {
                      e.target.src = "/default-avatar.png"; // Fallback on image load error
                    }}
                  />
                  <h1 className="font-bold text-insightful-black text-left lg:w-auto max-w-max lg:px-[20px] lg:ml-[20px]">
                    <span className="block text-[20px] md:text-[36px] lg:text-[62px] font-bold text-white leading-none">
                      {personalityName || "Find Your Personality"}
                    </span>
                    <span
                      className={`block text-[16px] md:text-[26px] font-semibold`}
                      style={{ color: personalityColorDark || "#000000" }}
                    >
                      {personalityType && (
                        <span className="text-insightful-black">
                          {t("dashboard.personality")}:{" "}
                        </span>
                      )}
                      {personalityInProgress && !personalityType && (
                        <>{t("dashboard.progress_message")}</>
                      )}

                      {personalityType && personalityType}

                      {!personalityType &&
                        !personalityInProgress &&
                        t("dashboard.highlighted_test")}
                    </span>
                    <span className="block text-[14px] md:text-[20px] text-white leading-tight font-normal text-wrap">
                      {insightfulContent?.content?.Content?.centerheading || ""}
                    </span>
                    <span className="w-fit hidden lg:flex">
                      {!personalityType && !personalityInProgress && (
                        <AppButton
                          type="button"
                          className="flex mt-[10px] justify-center items-center h-max w-full max-w-[320px] py-2 border border-transparent rounded-full shadow-sm text-[16px] lg:text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                          onClick={() => {
                            handleNavigateCurrentFilterTest(currentFilter);
                          }}
                        >
                          {t("dashboard.take_test_cta")}
                        </AppButton>
                      )}
                    </span>
                    <span className="w-fit hidden lg:flex">
                      {personalityInProgress && !personalityType && (
                        <AppButton
                          type="button"
                          className="flex mt-[10px] justify-center items-center h-max w-full max-w-[320px] py-2 border border-transparent rounded-full shadow-sm text-[16px] lg:text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                          onClick={() => {
                            handleContinueTest(
                              PERSONALITY_TEST_ASSESSMENT_ID,
                              inCompletePersonalityAssessmentId,
                            );
                            // scrollAndHighlightElement("new-test-button");
                            // setOpenNewTest(true);
                          }}
                        >
                          {t("dashboard.complete_test_cta")}
                        </AppButton>
                      )}
                    </span>
                  </h1>
                </div>
              ) : (
                <div
                  className="min-w-[300px] w-full max-h-full rounded-[20px] shadow-xl flex items-start bg-cover bg-center relative
                              px-[10px] pt-4 md:pt-6 pb-4 md:pb-6 lg:px-[10px] lg:pt-[10px] lg:pb-[5px] border-[3px] bg-custom-soft-gradient"
                  style={{
                    // // backgroundImage: bannerImage ? `url(${bannerImage})` : "none",
                    // background:
                    //   "linear-gradient(90deg, #DDF2FF 0%, #EDEAFF 51%, #FAF1FF 100%)",
                    // // Fallback background color
                    // opacity: 0.5,
                    borderColor: "#1D95FF",
                  }}
                >
                  <DashboardQuizB
                    handleContinueTest={handleContinueTest}
                    getAllAssessmentData={getAllAssessmentData}
                    attemptAssessmentIds={attemptAssessmentIds}
                  />
                </div>
              )}
            </div>
            {/* ------------------------------------SECOND SECTION------------------------------------ */}
            <div
              className={`w-full mx-auto lg:p-[10px] grid grid-cols-1 ${shouldHideAssessments ? "" : "md:grid-cols-[28%_72%]"} gap-1 md:items-stretch `}
            >
              <div className="w-full md:h-full md:min-h-0 md:relative">
                <div className="col-span-12 md:col-span-6 w-full md:absolute md:inset-0 md:min-h-0 mx-auto flex flex-col items-center">
                  {shouldHideAssessments ? null : (
                    <div className="hidden md:flex justify-between align-center items-center  max-w-[630px] w-full bg-transparent px-[20px] my-2">
                      <h2 className="font-[Montserrat] text-[20px] text-insightful-black font-bold">
                        {t("dashboard.results_label")}
                      </h2>

                      <button
                        id="filter-tests-sidepanel-button"
                        className={`md:hidden flex py-1 px-2 items-center text-[16px] text-insightful-purple font-semibold`}
                        onClick={toggleFilterPanel}
                      >
                        {t("dashboard.filter_tests_cta")}
                        <span>
                          <img
                            className="ml-2"
                            src={FilterTestIcon}
                            alt="Filter Tests Icon"
                          />
                        </span>
                      </button>
                    </div>
                  )}
                  <div className="max-w-full w-full px-2 bg-transparent rounded-[20px] md:px-0 overflow-y-auto md:flex md:flex-1 md:min-h-0 md:flex-col md:overflow-hidden">
                    {shouldHideAssessments ? null : (
                      <div className="flex justify-center relative shadow-xl rounded-[20px] w-full mx-auto items-stretch border-[1px] border-insightful-blue  md:h-full md:min-h-0 md:flex md:flex-col md:overflow-hidden border-l-[1px] border-r-[1px]">
                        <div className="md:min-h-0 md:flex-1 md:overflow-y-auto scrollbar-none [scrollbar-width:none] min-w-full ">
                          <table
                            id="assessment-table"
                            className="w-full text-[16px] text-left  rtl:text-right rounded-[20px] text-gray-500 dark:text-gray-400"
                            style={{ backgroundColor: "#F8F8F8" }}
                          >
                            <thead className="rounded-[20px] text-[16px] text-insightful-gray uppercase hover:bg-insightful-light-gray dark:bg-gray-700 relative dark:text-gray-400 ">
                              <tr className="md:hidden rounded-tl-[20px] rounded-tr-[20px] flex justify-between align-center items-center w-full bg-white px-[20px] my-2">
                                <h2 className="font-[Montserrat] text-[20px] text-insightful-black font-bold">
                                  {t("dashboard.results_label")}
                                </h2>
                                <button
                                  id="filter-tests-sidepanel-button-mobile-inside"
                                  className="flex py-1 px-2 items-center text-[16px] text-insightful-purple font-semibold"
                                  onClick={toggleFilterPanel}
                                >
                                  {t("dashboard.filter_tests_cta")}
                                  <span>
                                    <img
                                      className="ml-2"
                                      src={FilterTestIcon}
                                      alt="Filter Tests Icon"
                                    />
                                  </span>
                                </button>
                              </tr>
                            </thead>
                            <tbody
                              className="block w-full items-center overflow-y-auto max-h-[500px] md:max-h-none md:overflow-visible"
                              style={{
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                              }}
                            >
                              {filteredData?.length > 0 &&
                                (isMobile && !viewAllTests
                                  ? filteredData.slice(0, 4)
                                  : filteredData
                                )?.map((item, index) => {
                                  const status =
                                    item &&
                                    item?.personality &&
                                    item?.personality !== null
                                      ? ASSESSMENT_STATUS.COMPLETED
                                      : ASSESSMENT_STATUS.IN_PROGRESS;
                                  const translationStatus =
                                    item &&
                                    item?.personality &&
                                    item?.personality !== null
                                      ? `${t("dashboard.completed")}`
                                      : `${t("dashboard.in_progress")}`;
                                  const data = {
                                    userGuid: userGUID,
                                    assessmentAttemptId:
                                      item?.assessmentAttemptId,
                                    locale: currentLocale,
                                  };
                                  const reportType = item?.reportType;

                                  const testType =
                                    TEST_TYPES[item?.assessmentId] ||
                                    "UnknownTest";
                                  const getContent = () => {
                                    if (
                                      status === ASSESSMENT_STATUS.COMPLETED
                                    ) {
                                      const baseActions = [
                                        {
                                          label: `${t(
                                            "dashboard.view_report_cta",
                                          )}`,
                                          onClick: () => {
                                            handleViewReport(
                                              isPremiumOrGuest,
                                              item?.assessmentAttemptId,
                                              item?.assessmentId,
                                              item?.id,
                                              reportType,
                                            );
                                          },
                                          icon: ViewReportIcon,
                                          className: "text-red-500",
                                        },
                                        {
                                          label: `${t("dashboard.retake_test")}`,
                                          icon: RetakeTestIcon,
                                          onClick: () => {
                                            handleRetakeTest(item);
                                          },
                                        },
                                        {
                                          label: `${t("dashboard.share_report")}`,
                                          onClick: () => {
                                            handleShareReport(
                                              isPremiumOrGuest,
                                              item,
                                            );
                                          },
                                          icon: ShareReportIcon,
                                        },
                                        {
                                          label: `${t("dashboard.send_to_friend")}`,
                                          onClick: () => {
                                            handleSendToFriend(
                                              isPremiumOrGuest,
                                              item,
                                            );
                                          },
                                          icon: SendToFriendIcon,
                                        },
                                      ];

                                      // Hide standard View Report for RomanticCompatibilityTest
                                      const commonActions = baseActions;

                                      let specificActions = [];

                                      switch (testType) {
                                        case "PersonalityTest":
                                          specificActions = [
                                            {
                                              label: `${t(
                                                "dashboard.download_report",
                                              )}`,
                                              onClick: () => {
                                                handleDownloadReport(
                                                  isPremiumOrGuest,
                                                  item.assessmentAttemptId,
                                                );
                                              },
                                              icon: DownloadReportIcon,
                                            },
                                            {
                                              label: `${t(
                                                "dashboard.email_report",
                                              )}`,
                                              onClick: () => {
                                                handleEmailReport(
                                                  isPremiumOrGuest,
                                                  data,
                                                  item,
                                                );
                                              },
                                              icon: EmailReportIcon,
                                            },
                                          ];
                                          break;

                                        case "CareerTest":
                                          // No specific actions for CareerTest
                                          break;

                                        case "BigFiveTest":
                                          // No specific actions for BigFiveTest
                                          break;

                                        case "BigFiveFacetsTest":
                                          break;

                                        case "EnneagramTest":
                                          break;
                                        case "LikeabilityTest":
                                          break;
                                        case "PersonalityDisorderTest":
                                          break;
                                        case "DiscPersonalityTest":
                                          break;
                                        case "ADHDTest":
                                          break;
                                        case "CareerPreferenceTest":
                                          break;
                                        case "EmotionalIntelligenceTest":
                                          break;
                                        case "DifficultPersonTest":
                                          break;
                                        case "AutismSpectrumTest":
                                          break;
                                        case "HighlySensitivePersonTest":
                                          break;
                                        case "AttachmentStyleTest":
                                          break;
                                        case "RomanticCompatibilityTest":
                                          specificActions = [
                                            ...(isParentUser &&
                                            convertToLowerCase(reportType) ===
                                              convertToLowerCase(
                                                ROMANTIC_COMPATIBILITY_REPORT_TYPE.PERSONALIZED,
                                              )
                                              ? [
                                                  {
                                                    label: `${t(
                                                      "dashboard.send_to_partner",
                                                    )}`,
                                                    onClick: () => {
                                                      handleSendToPartner(
                                                        isPremiumOrGuest,
                                                        item,
                                                      );
                                                    },
                                                    icon: DownloadReportIcon,
                                                  },
                                                ]
                                              : []),
                                          ];
                                          break;
                                        default:
                                          specificActions = [];
                                          break;
                                      }

                                      return [
                                        ...commonActions,
                                        ...specificActions,
                                        {
                                          label: `${t("dashboard.delete_report")}`,
                                          onClick: () => {
                                            handleDeleteClick(
                                              item.assessmentId,
                                              item.assessmentAttemptId,
                                              item.id,
                                            );
                                          },
                                          icon: DeleteReportIcon,
                                          className: "text-red-500",
                                        },
                                      ];
                                    } else {
                                      return [
                                        {
                                          label: `${t("dashboard.continue_test")}`,
                                          onClick: () => {
                                            handleContinueTest(
                                              item?.assessmentId,
                                              item?.assessmentAttemptId,
                                            );
                                          },
                                          icon: PlayIcon,
                                        },
                                      ];
                                    }
                                  };

                                  const isDynamicPersonalityAssessment =
                                    convertToLowerCase(item?.assessmentId) ===
                                      convertToLowerCase(
                                        PERSONALITY_TEST_ASSESSMENT_ID,
                                      ) ||
                                    convertToLowerCase(item?.assessmentId) ===
                                      convertToLowerCase(
                                        ENNEAGRAM_TEST_ASSESSMENT_ID,
                                      ) ||
                                    convertToLowerCase(item?.assessmentId) ===
                                      convertToLowerCase(
                                        CAREER_TEST_ASSESSMENT_ID,
                                      );

                                  const staticPersonalityName =
                                    personalityNamesAndGroups[
                                      item?.assessmentId
                                    ]?.name ?? null;
                                  const staticPersonalityGroup =
                                    personalityNamesAndGroups[
                                      item?.assessmentId
                                    ]?.group ?? null;

                                  const pGroup =
                                    item?.personality &&
                                    item?.personality !== null
                                      ? item?.personality?.role?.toLowerCase()
                                      : isDynamicPersonalityAssessment
                                        ? personalityGroup
                                        : staticPersonalityGroup;

                                  const pName =
                                    item?.personality &&
                                    item?.personality !== null
                                      ? item?.nameEnglishCode?.toLowerCase()
                                      : isDynamicPersonalityAssessment
                                        ? personalityNameEnglishCode
                                        : staticPersonalityName;

                                  const isInProgressAssessment =
                                    convertToLowerCase(status) ===
                                    convertToLowerCase(
                                      ASSESSMENT_STATUS.IN_PROGRESS,
                                    );

                                  return (
                                    <React.Fragment key={index}>
                                      <tr
                                        className="flex justify-between max-h-max min-h-[100px]  w-full  md:first:rounded-t-[20px] md:last:rounded-b-[20px] hover:bg-custom-soft-gradient border-b last:border-b-0 border-insightful-light-gray dark:bg-gray-800 dark:border-gray-700 items-center py-2 cursor-pointer"
                                        onClick={() => {
                                          if (isInProgressAssessment) {
                                            dispatch(
                                              PushAssessmentAttemptIdToFunnelStep(
                                                item?.assessmentAttemptId,
                                              ),
                                            );
                                            dispatch(
                                              PushQuizCompleteToFunnelStep(
                                                false,
                                              ),
                                            );
                                            dispatch(
                                              PushBackClickCountToFunnelStep(0),
                                            );
                                            const path = PathHelper(
                                              APP_NAVIGATION.QUIZ,
                                              currentLocale,
                                            );
                                            navigate(
                                              `${path.next}?assessmentId=${item.assessmentId}&assessmentAttemptId=${item?.assessmentAttemptId}`,
                                            );
                                          } else {
                                            setAssessmentDetailOpen(true);
                                            setTestPanelOpen(
                                              item?.assessmentAttemptId,
                                            );
                                          }
                                        }}
                                      >
                                        <td className="min-w-max w-[45px] h-auto py-4 px-[5px] rounded-full overflow-hidden">
                                          <ResultProfileImage
                                            src={getImage(
                                              pGroup,
                                              pName,
                                              true,
                                              gender || userData?.gender,
                                              reportType,
                                            )}
                                            alt="Profile"
                                            className="object-cover rounded-full transition-transform transform scale-110 w-14 h-14 lg:mx-4 bg-gray-300"
                                          />
                                        </td>

                                        {/* Title Section */}
                                        <td className="flex flex-col justify-center items-start w-full gap-1">
                                          <p className="text-gray-500 font-bold text-[17px] sm:text-base">
                                            {item?.title}
                                            {item?.subtitle && (
                                              <span className="ml-2 text-gray-500 font-bold text-[10px]">
                                                ({item?.subtitle})
                                              </span>
                                            )}
                                          </p>

                                          <div
                                            className={`text-[12px] sm:text-sm flex gap-1 ${
                                              isInProgressAssessment
                                                ? "text-insightful-blue"
                                                : "text-insightful-green"
                                            }
                                                       cursor-pointer `}
                                            onClick={() => {
                                              if (isInProgressAssessment) {
                                                dispatch(
                                                  PushAssessmentAttemptIdToFunnelStep(
                                                    item?.assessmentAttemptId,
                                                  ),
                                                );
                                                dispatch(
                                                  PushQuizCompleteToFunnelStep(
                                                    false,
                                                  ),
                                                );
                                                dispatch(
                                                  PushBackClickCountToFunnelStep(
                                                    0,
                                                  ),
                                                );
                                                const path = PathHelper(
                                                  APP_NAVIGATION.QUIZ,
                                                  currentLocale,
                                                );
                                                navigate(
                                                  `${path.next}?assessmentId=${item.assessmentId}&assessmentAttemptId=${item?.assessmentAttemptId}`,
                                                );
                                              } else {
                                                setAssessmentDetailOpen(true);
                                                setTestPanelOpen(
                                                  item?.assessmentAttemptId,
                                                );
                                              }
                                            }}
                                          >
                                            {isInProgressAssessment
                                              ? "🅿️"
                                              : "✅"}
                                            <p>{translationStatus} </p>
                                            <p className="block md:hidden text-gray-500 text-[12px] sm:text-sm">
                                              {isInProgressAssessment
                                                ? t("dashboard.on")
                                                : t("dashboard.since")}
                                            </p>

                                            <p className=" text-gray-500 text-[12px] sm:text-sm">
                                              {moment(
                                                isInProgressAssessment
                                                  ? item?.lastModifiedOn
                                                  : item?.createdOn,
                                              ).format("MM/DD/YYYY")}
                                            </p>
                                          </div>
                                          <p className="text-[10px] sm:text-xs text-insightful-purple font-medium">
                                            {item?.assessmentCategoryName}
                                          </p>
                                        </td>

                                        <td
                                          className="px-2 py-4 text-right flex md:table-cell relative rounded-full items-center"
                                          onClick={(e) => {
                                            // Prevent row click when clicking on the 3 dots cell
                                            e.stopPropagation();
                                          }}
                                        >
                                          <button
                                            id={`three-dots-button-${
                                              item?.title || index
                                            }`}
                                            className="text-insightful-gray hover:text-insightful-black text-4xl font-bold text-left"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              if (window.innerWidth >= 768) {
                                                handlePopoverClick(index);
                                              } else {
                                                setTestPanelOpen(
                                                  item?.assessmentAttemptId,
                                                );
                                              }
                                            }}
                                          >
                                            &#x22EE;
                                          </button>
                                          {popoverOpen === index && (
                                            <div
                                              className="hidden sm:block absolute right-[10px] top-full z-50"
                                              data-popover-trigger
                                            >
                                              <AppPopOver
                                                className="text-right font-semibold text-xs bg-white"
                                                classNameList="text-[14px] text-left"
                                                isPopoverOpen={
                                                  popoverOpen === index
                                                }
                                                setIsPopoverOpen={
                                                  setPopoverOpen
                                                }
                                                content={getContent()}
                                                forceDownward={index < 5}
                                                enableDynamicPositioning={true}
                                              />
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  );
                                })}

                              {filteredData?.length === 0 && (
                                <tr className="flex w-full my-5">
                                  <td
                                    colSpan="3"
                                    className="flex flex-col justify-center items-center text-center h-full w-full px-2 md:px-0"
                                  >
                                    <p className="text-insightful-black text-[20px] w-full mx-auto">
                                      {t("dashboard.no_tests_message")}
                                    </p>
                                    <AppButton
                                      type="button"
                                      className="flex mt-[10px] justify-center items-center h-max w-full max-w-[320px] py-2 border border-transparent rounded-full shadow-sm text-[16px] lg:text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 px-4 sm:px-0"
                                      onClick={() => {
                                        handleNavigateCurrentFilterTest(
                                          currentFilter,
                                        );
                                      }}
                                    >
                                      {t("dashboard.take_test_cta")}
                                    </AppButton>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                            {filteredData?.length > 4 && (
                              <tfoot className="md:hidden bg-white ">
                                <tr>
                                  <td
                                    colSpan="3"
                                    className="text-center py-2 rounded-bl-[20px] rounded-br-[20px]"
                                  >
                                    <button
                                      className="w-full text-insightful-purple text-sm font-medium underline"
                                      onClick={() =>
                                        setViewAllTests(!viewAllTests)
                                      }
                                    >
                                      {viewAllTests
                                        ? t(
                                            "dashboard-b.achievements.show_less",
                                          )
                                        : t(
                                            "dashboard-b.assessment_table.view_all_your_tests",
                                          )}
                                    </button>
                                  </td>
                                </tr>
                              </tfoot>
                            )}
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* Mobile Test Panel */}
                {testPanelOpen !== null && !assessmentDetailOpen && (
                  <>
                    <div className="md:hidden max-h-max">
                      <div
                        className={`fixed flex flex-col mx-auto w-full bottom-0 max-h-max bg-white rounded-t-[20px] p-4 z-[1000] transform transition-transform duration-300 ease-in-out ${
                          testPanelOpen !== null
                            ? "translate-y-0"
                            : "translate-y-full scroll-smooth"
                        }`}
                      >
                        <div className="flex justify-between items-center mb-4">
                          <div className="text-left items-center px-2">
                            <h2 className="text-xl font-bold">
                              {selectedAssessment?.title}
                            </h2>
                            <p className="text-xs text-gray-500 ml-1">
                              {moment(selectedAssessment?.createdOn).format(
                                "MM/DD/YYYY",
                              )}
                              {selectedAssessment?.personality ? (
                                <span className="text-xs ml-2 text-green-500">
                                  {t("dashboard.complete_status")}
                                </span>
                              ) : (
                                <span className="text-xs ml-2 text-insightful-orange">
                                  {t("dashboard.incomplete_status")}
                                </span>
                              )}
                            </p>
                          </div>
                          <button
                            id="mobile-test-panel-button"
                            style={{
                              color: "white",
                              backgroundColor: "#805AED",
                            }}
                            className={`flex px-2 items-center min-w-max text-[16px]  rounded-full hover:bg-[${personalityColorMedium}] focus:bg-[${personalityColorMedium}]`}
                            onClick={() => setTestPanelOpen(null)}
                          >
                            {t("dashboard.close_button")}
                            <span className="text-[24px] ml-1">&times;</span>
                          </button>
                        </div>
                        <div className="space-y-[11px]">
                          {getMobileActions().map((item, index) =>
                            item.type === "divider" ? (
                              <hr
                                key={index}
                                className="border-t border-gray-200"
                              />
                            ) : (
                              <button
                                key={index}
                                className={`flex items-center w-full p-2 hover:bg-gray-100 rounded ${
                                  item.className || ""
                                }`}
                                onClick={item.onClick}
                              >
                                <img
                                  src={item.icon}
                                  alt={item.label}
                                  className="w-6 h-6 mr-2"
                                  style={{
                                    objectFit: "contain",
                                    transform: "scale(0.8)",
                                  }}
                                />
                                <span>{item.label}</span>
                              </button>
                            ),
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Overlay to close the panel when clicking outside */}
                    <div
                      className="fixed inset-0 bg-black bg-opacity-50 z-30 max-h-[100vh]"
                      onClick={() => setTestPanelOpen(null)}
                    ></div>
                  </>
                )}
                {/* Mobile Assessment Details Modal - shares its banner image
                    resolution/fallback with the desktop AssessmentOverview
                    card via getDashboardAssessmentBannerSrc/
                    DashboardAssessmentImage (see assessment-overview/). */}
                {(() => {
                  const mobileBannerImage = getDashboardAssessmentBannerSrc(
                    selectedAssessment?.assessmentId,
                  );
                  return (
                    <MobileBottomSheet
                      isOpen={assessmentDetailOpen}
                      onClose={() => {
                        setAssessmentDetailOpen(false);
                        setTestPanelOpen(null);
                      }}
                      personalityColorDark={personalityColorDark}
                      personalityColorLight={personalityColorLight}
                      personalityColorMedium={personalityColorMedium}
                      showCloseButton={true}
                    >
                      {/* Dynamic Banner Image - shared DashboardAssessmentImage (same component/fallback as desktop) */}
                      <div className="relative w-full min-h-[90px] mb-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg p-2 lg:p-6 text-white flex items-center justify-between">
                        {/* Show assessment name in gradient part when assessment is selected */}

                        <div className="absolute inset-0 flex items-center justify-center z-20">
                          <div className="relative w-full min-h-[90px] mb-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg p-3 text-white flex items-center">
                            {/* Icon */}
                            <DashboardAssessmentImage
                              src={mobileBannerImage}
                              alt={
                                selectedAssessment?.title
                                  ? `${selectedAssessment.title} icon`
                                  : ""
                              }
                              className="w-12 h-12 object-contain flex-shrink-0 mr-3"
                            />

                            {/* Title */}
                            <span className="text-white text-lg font-bold leading-tight text-left">
                              {selectedAssessment?.title}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="text-gray-600 flex flex-col justify-start items-start ">
                        <AssessmentDetailsBodyContent
                          selectedAssessment={selectedAssessment}
                          isPremiumOrGuest={isPremiumOrGuest}
                          handleViewReport={handleViewReport}
                          convertToLowerCase={convertToLowerCase}
                          t={t}
                          getAssessmentResultByAssessmentAttemptIdConnect={
                            getAssessmentResultByAssessmentAttemptIdConnect
                          }
                          currentLocale={currentLocale}
                          getInsightfulContentConnect={
                            getInsightfulContentConnect
                          }
                        />

                        <hr className="w-full my-2 border-t border-gray-200" />
                        <div className="w-full flex justify-between items-center gap-4 h-[36px]">
                          <div className="flex items-center gap-4">
                            <img
                              src={ShareReportIcon}
                              alt={"ShareReportIcon"}
                              className="w-6 h-6 block"
                              onClick={() => {
                                handleShareReport(
                                  isPremiumOrGuest,
                                  selectedAssessment,
                                );
                              }}
                            />

                            {selectedAssessment &&
                              convertToLowerCase(
                                selectedAssessment.assessmentId,
                              ) ===
                                convertToLowerCase(
                                  PERSONALITY_TEST_ASSESSMENT_ID,
                                ) && (
                                <img
                                  src={DownloadReportIcon}
                                  alt={"DownloadReportIcon"}
                                  className="w-6 h-6 block"
                                  onClick={() => {
                                    handleDownloadReport(
                                      isPremiumOrGuest,
                                      selectedAssessment.assessmentAttemptId,
                                    );
                                  }}
                                />
                              )}
                          </div>

                          <img
                            src={DeleteReportIcon}
                            alt={"DeleteReportIcon"}
                            className="w-6 h-6 block"
                            onClick={() => {
                              handleDeleteClick(
                                selectedAssessment.assessmentId,
                                selectedAssessment.assessmentAttemptId,
                                selectedAssessment.id,
                              );
                            }}
                          />
                        </div>
                      </div>
                    </MobileBottomSheet>
                  );
                })()}
                {/* New Test Modal */}
                <MobileBottomSheet
                  isOpen={isNewTestPopupOpen}
                  onClose={() => {
                    setIsNewTestPopupOpen(false);
                  }}
                  title=""
                  personalityColorDark={personalityColorDark}
                  personalityColorLight={personalityColorLight}
                  personalityColorMedium={personalityColorMedium}
                  showCloseButton={true}
                  categories={groupedCategories}
                  assessmentIcons={assessmentIcons}
                  isNewTest={true}
                  autoScrollOnOpen={true}
                  onItemClick={(assessmentId) => {
                    const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
                    navigate(
                      `${path.next}?assessmentId=${assessmentId}&newt=true`,
                    );
                    dispatch(PushAssessmentIdToFunnelStep(assessmentId));
                    handleTestClick();
                    setIsNewTestPopupOpen(false);
                  }}
                />
                {/* Share Modal */}
                {shareModalOpen && (
                  <ShareProfileModal
                    isOpen={shareModalOpen}
                    onClose={() => {
                      setShareModalOpen(false);
                      fetchSocialShareCount();
                    }}
                    personalityImage={getImage(
                      selectedTest?.personality?.role.toLowerCase()
                        ? selectedTest?.personality?.role.toLowerCase()
                        : personalityGroup.toLowerCase(),
                      selectedTest?.nameEnglishCode.toLowerCase()
                        ? selectedTest?.nameEnglishCode.toLowerCase()
                        : personalityNameEnglishCode.toLowerCase(),
                      true,
                      gender || userData?.gender,
                    )}
                    assessmentTitle={
                      selectedTest?.title
                        ? selectedTest?.title
                        : userAssessmentResult.assessmentTitle
                    }
                    assessmentId={
                      selectedTest?.assessmentId
                        ? selectedTest?.assessmentId
                        : userAssessmentResult?.assessmentId
                    }
                    assessmentAttemptId={
                      selectedTest?.assessmentAttemptId
                        ? selectedTest?.assessmentAttemptId
                        : latestAssessmentAttemptId
                    }
                    personalityType={
                      selectedTest?.personality?.title
                        ? selectedTest?.personality?.title
                        : personalityType
                    }
                    personalityName={
                      selectedTest?.personality?.name
                        ? selectedTest?.personality?.name
                        : personalityName
                    }
                    personalityGroup={
                      selectedTest?.personality?.role
                        ? selectedTest?.personality?.role
                        : personalityGroup
                    }
                    userGUID={userGUID}
                    saveUserSocialButtonClickConnect={
                      saveUserSocialButtonClickConnect
                    }
                  />
                )}{" "}
                {takeAssessmentModalOpen && (
                  <TakeAssessmentModal
                    isOpen={takeAssessmentModalOpen}
                    onClose={() => {
                      setTakeAssessmentModalOpen(false);
                      setShowOnlySpecificCategories(false);
                    }}
                    allAssessments={allAssessments}
                    assessmentIcons={assessmentIcons}
                    assessmentAttemptStatuses={assessmentAttemptStatuses}
                    handleContinueTest={handleContinueTest}
                    handleStartAssessment={handleStartAssessment}
                    isPremiumOrGuest={isPremiumOrGuest}
                    showOnlySpecificCategories={showOnlySpecificCategories}
                    isAttemptUserAllAssessments={isAttemptUserAllAssessments}
                  />
                )}{" "}
              </div>
              <div>
                <div className="w-full">
                  <div className="flex justify-between align-center items-center  max-w-[630px] w-full bg-transparent px-[20px] md:px-[10px] my-2">
                    <h2 className="hidden md:block font-[Montserrat] text-[20px] text-insightful-black font-bold">
                      {t("report.career_test.overview")}
                    </h2>
                  </div>
                  {/* First Row: 2 Cards in a Single Grid when no assessments */}
                  <div
                    className={`grid grid-cols-1 ${shouldHideAssessments || !selectedAssessment ? "md:grid-cols-2" : "md:grid-cols-3"} gap-4 px-[10px] items-stretch`}
                  >
                    {/* Card 1 */}

                    {selectedAssessment &&
                      !shouldHideAssessments &&
                      !isMobile &&
                      assessmentAttemptData.length > 0 && (
                        <AssessmentOverview
                          selectedAssessment={selectedAssessment}
                          isPremiumOrGuest={isPremiumOrGuest}
                          handleViewReport={handleViewReport}
                          handleShareReport={handleShareReport}
                          handleDownloadReport={handleDownloadReport}
                          handleDeleteReport={handleDeleteReport}
                          handleDeleteClick={handleDeleteClick}
                          PERSONALITY_TEST_ASSESSMENT_ID={
                            PERSONALITY_TEST_ASSESSMENT_ID
                          }
                          convertToLowerCase={convertToLowerCase}
                          ShareReportIcon={ShareReportIcon}
                          DownloadReportIcon={DownloadReportIcon}
                          DeleteReportIcon={DeleteReportIcon}
                          t={t}
                          personalityImage={personalityImage}
                          bannerImage={bannerImage}
                          getAssessmentResultByAssessmentAttemptIdConnect={
                            getAssessmentResultByAssessmentAttemptIdConnect
                          }
                          currentLocale={currentLocale}
                          getInsightfulContentConnect={
                            getInsightfulContentConnect
                          }
                        />
                      )}

                    {/* Card 2 */}
                    <InviteCard
                      title={t("dashboard-b.discovery.discovery")}
                      description={
                        isAttemptUserAllAssessments
                          ? t("dashboard-b.discovery.congratulations_text")
                          : t("dashboard-b.discovery.who_you_are")
                      }
                      highlightColor="#805AED"
                      subText={
                        isAttemptUserAllAssessments
                          ? t("dashboard-b.discovery.congratulations_sub_text")
                          : t("dashboard-b.discovery.relate_to_others")
                      }
                      buttonText={t("dashboard-b.discovery.btn")}
                      buttonWidth="80%"
                      buttonColor="#FE6634"
                      onButtonClick={() => {
                        // setIsNewTestPopupOpen(true);
                        setTakeAssessmentModalOpen(true);
                      }}
                    />
                    {/* Card 3 - Achievements */}
                    <div id="achievements-card">
                      <AchievementsCard
                        expandedAchievement={expandedAchievement}
                        setExpandedAchievement={setExpandedAchievement}
                        openedAssessmentAchievement={
                          openedAssessmentAchievement
                        }
                        setOpenedAssessmentAchievement={
                          setOpenedAssessmentAchievement
                        }
                      />
                    </div>
                  </div>
                </div>

                {/*SECOND ROW —  cards 1 */}
                <div className="grid grid-cols-1 md:grid-cols-2 px-[10px] gap-4 mt-4">
                  <InviteCard
                    title={t("dashboard-b.friends.friends")}
                    description={t("dashboard-b.friends.friends_and_family", {
                      remaining:
                        billingDetails?.maxSubUserCount - guestUserCount || 0,
                    })}
                    highlightText={(
                      billingDetails?.maxSubUserCount - guestUserCount || 0
                    ).toString()}
                    highlightColor="#805AED"
                    subText={t("dashboard-b.friends.free_account")}
                    subtexthighlight="FREE"
                    subtexthighlightcolor="#805AED"
                    buttonText={t("dashboard-b.friends.btn")}
                    buttonWidth="75%"
                    buttonColor="#805AED"
                    manageText={t("dashboard-b.friends.manage_invites")}
                    manageColor="#805AED"
                    onButtonClick={() => {
                      handleInviteFriend();
                    }}
                    onManageClick={() => {
                      if (isPremiumOrGuest) {
                        navigate(`${settingsPath.next}?steps=user_management`);
                      } else {
                        navigate(`${planPath.next}`);
                      }
                    }}
                  />
                  {/*SECOND ROW —  cards 2 */}
                  <InviteCard
                    title={t("dashboard-b.discovery.discovery")}
                    description={
                      isAttemptUserAllAssessments
                        ? t("dashboard-b.discovery.congratulations_text")
                        : t("dashboard-b.discovery-b.revealed", {
                            percentage: Math.round(
                              (getAllAssessmentAttemptData.length /
                                allAssessments.length) *
                                100,
                            ),
                          })
                    }
                    highlightText={`${Math.round(
                      (getAllAssessmentAttemptData.length /
                        allAssessments.length) *
                        100,
                    )}%`}
                    highlightColor="#805AED"
                    subText={
                      isAttemptUserAllAssessments
                        ? t("dashboard-b.discovery.congratulations_sub_text")
                        : t("dashboard-b.discovery-b.accuracy")
                    }
                    subTextColor="#000000"
                    buttonText={
                      !isAttemptUserAllAssessments &&
                      t("dashboard-b.discovery-b.btn")
                    }
                    buttonWidth="75%"
                    buttonColor="#805AED"
                    manageText={t("dashboard-b.discovery-b.btn-b")}
                    manageColor="#805AED"
                    onButtonClick={() => {
                      setShowOnlySpecificCategories(true);
                      setTakeAssessmentModalOpen(true);
                    }}
                    onManageClick={handleTakeRandomQuiz}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Filter Tests Bottom Mobile Panel */}
      <div
        id="filter-tests-mobile"
        className={`md:hidden fixed  flex items-center justify-center flex-col mx-auto w-full bottom-0 h-max py-[10px] bg-white  shadow-lg rounded-t-[20px] transform transition-transform duration-300 ease-in-out z-[1000] ${
          isFilterPanelOpen
            ? "translate-y-0 scroll-smooth"
            : "translate-y-full scroll-smooth"
        }`}
      >
        <div className="w-full px-[20px] h-max">
          <div className=" flex justify-between align-center items-center md:hidden max-w-full w-full bg-transparent md:px-0 my-2">
            <h2 className="font-[Montserrat] text-[24px] text-insightful-black font-bold text-left">
              {t("dashboard.filter_tests_cta")}
            </h2>
            <button
              id="filter-tests-sidepanel-button"
              style={{
                color: "white",
                backgroundColor: "#805AED",
              }}
              className={`flex py-1 px-2 items-center min-w-max text-[16px] rounded-full`}
              onClick={toggleFilterPanel}
            >
              {t("dashboard.close_button")}
              <span className="text-[24px] ml-1">&times;</span>
            </button>
          </div>
          <div className="w-full flex-row overflow-y-auto overscroll-contain  h-[200px]">
            <button
              onClick={() => {
                setCurrentFilter("All");
                toggleFilterPanel();
              }}
              className="flex items-center font-medium text-[16px] text-insightful-black mb-2 text-left w-full hover:bg-insightful-lightest-gray focus:bg-insightful-lightest-gray rounded-[10px] py-[8px] px-[8px]"
            >
              <img src={AllIcon} alt="All" className="w-6 h-6 mr-2" />
              {t("dashboard.all_text")}
            </button>
            {assessmentFilterOption.length &&
              [...assessmentFilterOption]
                .sort((a, b) => a.title.localeCompare(b.title))
                .map((item) => {
                  return (
                    <button
                      onClick={() => {
                        setCurrentFilter(item?.id);
                        toggleFilterPanel();
                      }}
                      className="flex items-center font-medium text-[16px] text-insightful-black mb-3 text-left w-full hover:bg-insightful-light-gray focus:bg-insightful-light-gray rounded-[20px] py-[8px] px-[8px]"
                    >
                      <img
                        src={item?.icon}
                        alt="All"
                        className="w-6 h-6 mr-2"
                        style={{ objectFit: "contain" }}
                      />
                      {item?.title}
                    </button>
                  );
                })}

            <button className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-2 text-left w-full hover:bg-insightful-lightest-gray focus:bg-insightful-lightest-gray rounded-[10px] py-[8px] px-[8px]">
              <img
                src={LearningStyle}
                alt="Learning Style"
                className="w-6 h-6 mr-2"
              />
              {t("dashboard.learning_style")}
            </button>
            <button className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-2 text-left w-full hover:bg-insightful-lightest-gray focus:bg-insightful-lightest-gray rounded-[10px] py-[8px] px-[8px]">
              <img
                src={StressManagement}
                alt="Stress Management"
                className="w-6 h-6 mr-2"
              />
              {t("dashboard.stress_management")}
            </button>
          </div>
        </div>

        <hr className="border-t border-insightful-light-gray w-full my-6" />

        <div className="flex items-center flex-col justify-center text-center mb-6 px-[20px]">
          <p className="font-semibold text-[16px] text-insightful-black mb-4">
            {t("dashboard.remaining_invites_text")}{" "}
            <span style={{ color: personalityColorDark }}>
              {/* 8 userInvitations */}
              {parseInt(billingDetails?.maxSubUserCount) -
                parseInt(guestUserCount) || 0}{" "}
            </span>{" "}
            {t("dashboard.invite_friend_info")}
          </p>
          <button
            type="button"
            className="flex flex-col justify-center items-center h-[30px] w-[150px] border border-transparent rounded-full shadow-sm text-[12px] font-semibold text-insightful-black bg-[#D9D9D9] hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
            onClick={() => {
              if (isPremiumOrGuest) {
                if (guestUserCount < billingDetails?.maxSubUserCount) {
                  setOpenCreateUser(true);
                  toggleFilterPanel();
                } else {
                  toast.warning(t("settings.max_user_reached_msg"));
                }
              } else {
                const path = PathHelper(APP_NAVIGATION.PLAN, currentLocale);
                navigate(`${path.next}`); // for example
                // navigate(ROUTE_CONSTANT.PAYMENT_PLAN);
              }
            }}
          >
            <span> {t("dashboard.invite_friend_cta")} </span>
          </button>

          <Link
            to={
              isPremiumOrGuest
                ? `${settingsPath.next}?steps=user_management#user-management`
                : planPath.next
            }
            className={`my-2
                              style={{ color: personalityColorDark }}
                               underline-offset-2 underline`}
          >
            {t("dashboard.manage_invites_cta")}
          </Link>
        </div>
      </div>

      <CreateNewUserModel
        isOpen={openCreateUser}
        setOpen={setOpenCreateUser}
        parentId={userGUID}
        CreateGuestUserConnect={GuestUserChangesConnect}
        GetGuestUserConnect={GetGuestUserConnect}
        setGuestUserData={setGuestUserData}
        setGuestUserCount={setGuestUserCount}
        parentEmail={userData?.email}
        guestUserData={guestUserData}
        currentLocale={currentLocale}
        t={t}
      />
      <CreateNewUserModel
        isOpen={openSendToPartner}
        setOpen={setOpenSendToPartner}
        parentId={userGUID}
        CreateGuestUserConnect={sendToPartnerReportOnEmailConnect}
        parentEmail={userData?.email}
        guestUserData={guestUserData}
        assessmentAttemptId={selectedAssessmentAttemptId}
        assessmentId={selectedAssessmentId}
        type={"send_to_partner"}
        assessmentMapId={selectedAssessmentMapId}
        t={t}
        currentLocale={currentLocale}
        isPremiumOrGuest={isPremiumOrGuest}
        guestUserCount={guestUserCount}
        maxSubUserCount={billingDetails?.maxSubUserCount}
      />
      <CreateNewUserModel
        isOpen={openSendToFriend}
        setOpen={setOpenSendToFriend}
        parentId={userGUID}
        CreateGuestUserConnect={sendToFriendReportOnEmailConnect}
        parentEmail={userData?.email}
        guestUserData={guestUserData}
        assessmentAttemptId={selectedAssessmentAttemptId}
        assessmentId={selectedAssessmentId}
        type={"send_to_friend"}
        reportType={selectedReportType}
        id={selectedResultId}
        t={t}
        currentLocale={currentLocale}
      />
      {/* Overlay to close the panel when clicking outside */}
      {isFilterPanelOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 max-h-[100vh]"
          onClick={toggleFilterPanel}
        ></div>
      )}
      {/* Share Modal */}
      {shareModalOpen && (
        <ShareProfileModal
          isOpen={shareModalOpen}
          onClose={() => {
            setShareModalOpen(false);
            fetchSocialShareCount();
          }}
          personalityImage={getImage(
            selectedTest?.personality?.role.toLowerCase()
              ? selectedTest?.personality?.role.toLowerCase()
              : personalityGroup.toLowerCase(),
            selectedTest?.nameEnglishCode.toLowerCase()
              ? selectedTest?.nameEnglishCode.toLowerCase()
              : personalityNameEnglishCode.toLowerCase(),
            true,
            gender || userData?.gender,
          )}
          assessmentTitle={
            selectedTest?.title
              ? selectedTest?.title
              : userAssessmentResult.assessmentTitle
          }
          assessmentId={
            selectedTest?.assessmentId
              ? selectedTest?.assessmentId
              : userAssessmentResult?.assessmentId
          }
          assessmentAttemptId={
            selectedTest?.assessmentAttemptId
              ? selectedTest?.assessmentAttemptId
              : latestAssessmentAttemptId
          }
          personalityType={
            selectedTest?.personality?.title
              ? selectedTest?.personality?.title
              : personalityType
          }
          personalityName={
            selectedTest?.personality?.name
              ? selectedTest?.personality?.name
              : personalityName
          }
          personalityGroup={
            selectedTest?.personality?.role
              ? selectedTest?.personality?.role
              : personalityGroup
          }
          userGUID={userGUID}
          saveUserSocialButtonClickConnect={saveUserSocialButtonClickConnect}
        />
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteConfirmModal && (
        <ShareProfileModal
          isOpen={showDeleteConfirmModal}
          onClose={handleCloseDeleteConfirm}
          isDeleteConfirm={true}
          onConfirmDelete={handleConfirmDelete}
        />
      )}

      {/* <Footer /> */}
      <Footerb
        onInviteClick={() => {
          if (isPremiumOrGuest) {
            if (guestUserCount < billingDetails?.maxSubUserCount) {
              setOpenCreateUser(true);
            } else {
              toast.warning(t("settings.max_user_reached_msg"));
            }
          } else {
            const path = PathHelper(APP_NAVIGATION.PLAN, currentLocale);
            navigate(`${path.next}`);
          }
        }}
        onPlusClick={() => {
          setIsNewTestPopupOpen(true);
        }}
        onPlusClose={() => {
          setIsNewTestPopupOpen(false);
        }}
      />
    </div>
  );
};

export default Dashboard;

const CompletedAssessments = ({
  completedAsssessmentData,
  t,
  gender,
  personalityGroup,
  personalityNameEnglishCode,
  isPremiumOrGuest,
  handleShareReport,
  convertToLowerCase,
  personalityNamesAndGroups,
}) => {
  const [showAll, setShowAll] = useState(false);

  // Always show full data when showAll = true
  const displayedData = showAll
    ? completedAsssessmentData
    : completedAsssessmentData?.slice(0, 4);

  return (
    <div className="max-w-full w-full bg-transparent">
      <div
        className="flex flex-col relative lg:shadow-md 
        md:rounded-[20px] overflow-hidden
        w-full mx-auto md:border-insightful-blue md:border"
      >
        {/* Scroll only when showAll is true */}
        <div
          className={`w-full transition-all duration-300 ${
            showAll
              ? "max-h-[420px] md:max-h-[500px] overflow-y-auto"
              : "max-h-auto overflow-hidden"
          } scrollbar-hide`}
          style={{
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <table
            className="w-full text-[14px] md:text-[15px] text-left rtl:text-right 
            text-gray-500 dark:text-gray-400"
            style={{ backgroundColor: "#F8F8F8" }}
          >
            <tbody>
              {displayedData?.length > 0 &&
                displayedData.map((item, index) => {
                  const reportType = item?.reportType;

                  const isDynamicPersonalityAssessment =
                    convertToLowerCase(item?.assessmentId) ===
                      convertToLowerCase(PERSONALITY_TEST_ASSESSMENT_ID) ||
                    convertToLowerCase(item?.assessmentId) ===
                      convertToLowerCase(ENNEAGRAM_TEST_ASSESSMENT_ID) ||
                    convertToLowerCase(CAREER_TEST_ASSESSMENT_ID);

                  const staticPersonalityName =
                    personalityNamesAndGroups[item?.assessmentId]?.name ?? null;
                  const staticPersonalityGroup =
                    personalityNamesAndGroups[item?.assessmentId]?.group ??
                    null;

                  const pGroup =
                    item?.personality && item?.personality !== null
                      ? item?.personality?.role?.toLowerCase()
                      : isDynamicPersonalityAssessment
                        ? personalityGroup
                        : staticPersonalityGroup;

                  const pName =
                    item?.personality && item?.personality !== null
                      ? item?.nameEnglishCode?.toLowerCase()
                      : isDynamicPersonalityAssessment
                        ? personalityNameEnglishCode
                        : staticPersonalityName;

                  return (
                    <tr
                      key={index}
                      className="flex justify-between min-h-[70px] md:min-h-[80px] w-full 
                      md:first:rounded-t-[20px] md:last:rounded-b-[20px] 
                      hover:bg-custom-soft-gradient border-b last:border-b-0 
                      border-insightful-light-gray items-center 
                      py-1 px-2 md:py-2 cursor-pointer transition-all duration-200"
                      onClick={() => handleShareReport(isPremiumOrGuest, item)}
                    >
                      <td className="w-[50px] flex justify-center">
                        <ResultProfileImage
                          src={getImage(
                            pGroup,
                            pName,
                            true,
                            gender,
                            reportType,
                          )}
                          alt="Profile"
                          className="object-cover rounded-full
                          w-10 h-10 md:w-12 md:h-12 bg-gray-300"
                        />
                      </td>

                      <td className="flex flex-col justify-center items-start w-full gap-1 pl-2">
                        <p className="text-gray-600 font-semibold text-[13px] md:text-[14px] leading-tight">
                          {item?.title}
                          {item?.subtitle && (
                            <span className="ml-1 text-gray-500 font-medium text-[10px]">
                              ({item?.subtitle})
                            </span>
                          )}
                        </p>

                        <p className="text-[10px] md:text-[11px] text-insightful-purple font-medium">
                          {item?.assessmentCategoryName}
                        </p>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>

        {/*Button That Works for both Action */}
        {completedAsssessmentData?.length > 4 && (
          <div className="w-full text-center py-1 bg-white border-t border-insightful-light-gray">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setShowAll((prev) => !prev);
              }}
              className="text-insightful-purple font-medium text-sm hover:underline transition-all underline duration-200"
            >
              {showAll
                ? t("dashboard-b.achievements.show_less")
                : t("dashboard-b.assessment_table.view_all_your_assessment")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
